<template> 
	<div class="container-fluid" id="mainDiv">
<!-- DRAGGIE DIVS             -->
	<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in">
 	<div class="masterDraggie">
	 	<div class="draggieContainer">

		 		<div 	v-show="voice1Div"
						:class="voice1DivClass"
						class="voice1Draggable"
						id="voice1DivID"
						@click="voice1DraggieClick">

					<strong><p id="voiceBubbleText">PART 1 </p> 
					<p id="voiceBubbleText2"> {{voice1CurrentInstrument}} </p></strong>
				</div>

				<div 	v-show="voice2Div"
						:class="voice2DivClass"
						class="voice2Draggable"
						id="voice2DivID"
						@click="voice2DraggieClick">

					<strong><p id="voiceBubbleText">PART 2 </p> 
					<p id="voiceBubbleText2"> {{voice2CurrentInstrument}} </p></strong>
				</div>

				<div 	v-show="voice3Div"
						:class="voice3DivClass"
						class="voice3Draggable"
						id="voice3DivID"
						@click="voice3DraggieClick">

					<strong><p id="voiceBubbleText">PART 3 </p> 
					<p id="voiceBubbleText2"> {{voice3CurrentInstrument}} </p></strong>
				</div>

				<div 	v-show="voice4Div"
						:class="voice4DivClass"
						class="voice4Draggable"
						id="voice4DivID"
						@click="voice4DraggieClick">

					<strong><p id="voiceBubbleText">PART 4 </p> 
					<p id="voiceBubbleText2"> {{voice4CurrentInstrument}} </p></strong>
				</div>

				<div 	
						v-show="playSunDiv"
						class="playSunDraggable"
						id="playSunDivID"
						@click="playSunDraggieClick">
						<p id="sunTextID"> 
						{{sunText}} 
						</p>
						<p id="sunTextID2"> 
						{{sunText2}} 
						</p>
						<p id="sunLoadText1"> 
						{{sunLoad1}} 
						</p>
						<p id="sunLoadText2"> 
						{{sunLoad2}} 
						</p>
						<p id="togetherText"> 
						{{allTogetherSunText}} 
						</p>
				</div>

				<div 	
						v-show="aboutDiv"
						class="aboutDraggable"
						id="aboutDivID">
						
						<p id="createdByHeader">
						CREATED BY: 	
						</p>

						<p id="aboutTextID"> 
		  					<a href="https://www.mattmccorkle.com" target="_blank" style="color: black"> 
		  					<u>Matt McCorkle</u> </a>

		  					<br>

		  					<a href="https://www.newinc.org" target="_blank" style="color: black">
		  					<p id="newINC"> (at <u>NEW INC</u>) </p> </a>

		  					<br>
		  					&
		  					<br>

		  					<a href="http://www.samreidermusic.com/" target="_blank" style="color: black"> <u>
		  					Sam Reider </u></a>
						</p>

						
				</div>

				<div 	
						v-show="aboutDiv"
						class="about2Draggable"
						id="aboutDivID">
						<p id="about2TextID">
							FEATURING:
		  				</p>
		  				<p id="about2TextID1">
		  					Clarinet: <a href="http://markdovermusic.com/" target="_blank" style="color: black"> <u>
		  					Mark Dover</u></a>
		  					<br>

		  					Violin & Viola: <a href="http://www.alexhargreaves.net" target="_blank" style="color: black"> <u>
		  					Alex Hargreaves</u></a>
		  					<br>

		  					Cello: <a href="http://www.thebrotherbrothersmusic.com" target="_blank" style="color: black"> <u>
		  					David Moss</u></a>
		  					<br>

		  					Piano & Celesta: Sam Reider
		  					<br>
		  					Accordion: Sam Reider
		  					<br>
		  					Sound Design: Matt McCorkle
		  					<br>
		  					<br>
		  					Special Thanks:
		  					<a href="http://www.samreidermusic.com/" target="_blank" style="color: black"><u>Tone.js</u></a>
		  				</p>	
						

				</div>

				<div 	
						v-show="aboutDiv"
						class="about3Draggable"
						id="aboutDivID">

						<p id="about3TextHeader"> 
							ABOUT:
						</p>

						<p id="about3TextID"> 

							A harmonious New Year's sound experiment. Harmony has the ability to create rich musical expressions. This project explores harmony and the different textures it creates. Explore all the different instruments performing this four-part harmony.
		  					<br>
		  					<br>
		  					This project features Auld Lang Syne arranged in a four-part harmony. Click each revolving orb to reveal a new instrument for each part. Control volume and speed in the MUSIC MIXER section and add seasonal sounds in the AMBIENCES section.
		  				
		  					
						</p>

						
				</div>

				<div 	
						v-show="aboutDiv"
						class="about4Draggable"
						id="aboutDivID">

		  				<p id="mailingListText" style="color: black"> Stay in touch for new project releases! 
						<br>
						</p>
						<!-- <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css"> -->
						<div id="mc_embed_signup">
						<form action="https://space.us12.list-manage.com/subscribe/post?u=cc407290614bbaa2daa32fe9e&amp;id=219d3ce36c" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
						    <div id="mc_embed_signup_scroll">
							
							<input type="email" 
								   value="" 
								   name="EMAIL" 
								   class="email" 
								   id="mce-EMAIL" 
								   placeholder="email address" required>
						    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
						    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_cc407290614bbaa2daa32fe9e_219d3ce36c" tabindex="-1" value=""></div>
						<br>
						
						<input 	type="submit" 
							    value="Subscribe!" 
							    name="subscribe" 
							    id="mc-embedded-subscribe">
						    </div>
						</form>
						</div>
		  				 
							    <!-- @click="mailingListBtn = !mailingListBtn"
							    :class="mailingListBtnClass" -->
		  					

						
				</div>
		</div>
	</div>	
	</transition>		
<!-- NAVIGATION               -->
		<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in"
					>

		<!-- <transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in"> -->			

			<div class="col-xs-12" id="navBar" v-if="showNavBar" key="firstNav">	
				<div class="row">
				
					<button class="btn btn" id="harmonizeHeading" 
							:class="harmonyClass" 
							@click="harmonyMixingPane">
							 MUSIC MIXER	
					</button>
			
					<button
							id="cuteBtn"
							:class="helpClass"
							class="btn btn-info"
							@click="goToHelp">
					<strong> <i class="fa fa-question" aria-hidden="true"></i> </strong>
					</button>
				
					<button class="btn btn" id="ambienceHeading"
							:class="ambianceClass" 
							@click="ambianceMixingPane">
							 AMBIENCES
					</button>	
			</div>	
			</div>	
		<!-- </transition> -->
		</transition>

		<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated fadeOutDownBig"  
					mode="out-in"
					appear>
		<div class="col-xs-12" id="navBar" v-if="showHorn" key="secondNav">	
				<div class="row">
					  <button 	type="button" 
					  			id="hornBtn"
					  			:class="hornClass"
					  			@click="hornBlow">
					  			 <p id="hornBtnPrompt">
					  				Make Noise 
					  				<i 	
					  				:class="hornStartStopIcon" 
					  				v-bind:style="{'color': hornTrigger ? stopColor : playColor }" 
					  				aria-hidden="true">	
					  				</i> While Loading
					  </p>
					  </button>
				</div>
			</div>
		</transition>
<!-- PROMPT 				  -->
	<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in">
	 	<div class="col-xs-12" v-show="showPrompt">

	 		<p id="promptText">
	 			Click an orb to change instruments on each part of the harmony.
	 		</p>

	 		<button 
					id="promptButton"
					:class="promptButtonClass"
					@click="promptFunc"
					>Got It <i class="fa fa-check" style="color:white"></i>
			</button>


	 	</div>
	</transition>

	<transition
					enter-active-class="animated fadeIn"
					leave-active-class="animated pulse"  
					mode="out-in">
	 	<div class="col-xs-12" v-show="showMutePrompt">

			<p id="promptText"> 
				<i :class="bellSlash"></i> </i> 
				<br>
			    Loading may take a few moments.
			    <br> 
			    Please make sure your <strong> mute button is off </strong> and volume is engaged.
			</p>
		</div>
	</transition>
<!-- MASTER CONTROL           -->
	<div class="container-fluid" id="controlsContainer">
		<div id="masterControlDiv" v-show="showMissionControl">
				<div class="col-xs-2" id="voice1SliderDiv">
						<button id="masterControlBadges"
										class="voice1Badge"
										@click="voice1BadgeClick"
										>PART 1 VOLUME</button>
						<input
							id="sliders1" 
							type="range"
							class="instrument1Ranger"
							v-model="voice1Radius"
							:="voice1RadiusFunc"
							step="1"
							>
						</input>
				</div>
				<div class="col-xs-2" id="voice2SliderDiv">
						<button id="masterControlBadges"
										class="voice2Badge"
										@click="voice2BadgeClick"
										>PART 2 VOLUME</button>
						<input 
							id="sliders2"
							type="range"
							class="instrument2Ranger"
							v-model="voice2Radius"
							:="voice2RadiusFunc"
							step="1"
							>		<!-- @click="voice2DraggieClick" -->
						</input>
				</div>
				<div class="col-xs-2" id="voice3SliderDiv">
						<button id="masterControlBadges"
										class="voice3Badge"
										@click="voice3BadgeClick"
										>PART 3 VOLUME</button>	
						<input 
							id="sliders3"
							type="range"
							class="instrument3Ranger"
							v-model="voice3Radius"
							:="voice3RadiusFunc"
							step="1"
							>	<!-- @click="voice3DraggieClick" -->
						</input>
				</div>
				<div class="col-xs-2" id="voice4SliderDiv">
						<button id="masterControlBadges" 
										class="voice4Badge"
										@click="voice4BadgeClick"
										>PART 4 VOLUME</button>	
						<input 
							id="sliders4"
							type="range"
							class="instrument4Ranger"
							v-model="voice4Radius"
							:="voice4RadiusFunc"
							step="1"
							>	<!-- @click="voice4DraggieClick" -->
						</input>
				</div>

				<!-- <div class="col-xs-2" id="playButtonDiv">
						<button 
							id="playButton"
							class="btn btn-default btn-lg" 
							@click="startStop"
							:="keyboardTriggering" 
							:class="startStopClass"
							>
							<span :class="startStopIcon" v-bind:style="{'color': startStopTrigger ? stopColor : playColor }"></span>
						</button>
				</div>
 -->

			<div id="timingSmoosh">
				<div class="col-xs-2" id="daySliderDiv">
						<button id="masterTimingBadges">MUSIC VOLUME</button> <!-- {{masterVolume}}dB -->
						<input 
							id="sliders5" 
							type="range"
							class="dayRanger"
							v-model="masterVolume"
							:="masterVolumeMixing"
							max="12" min="-30" step="1"
							></input>
				</div>
				<div class="col-xs-2" id="timingSliderDiv">
						<button id="masterTimingBadges">SPEED</button>		
						<input
							id="slidersTiming" 
							type="range"
							class="timingRanger"
							v-model="masterTiming"
							:="masterTimingFunc"
							max="0.2" min="0.02" step=".0001"
							></input>
				</div>
				
			</div>

			<br>
			<br>
			<!-- <p id="harmonyInfo"> Click a org change  </p>	 -->
		</div>
<!-- AMBIANCES                -->
						<div id="ambienceBtnLocation" v-show="showAmbiances">
								<div class="col-xs-2" id="ambienceBtn1Div">

									<button 
										id="ambienceBtns"
										:class="ambience1Class"
										@click="ambience1Func"
										> <i :class="ambience1Icon" style="color:white"></i>
										PEOPLE
										</button>

										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance1RangerClass"
											v-model="ambience1Vol"
											:="ambienceMixing"
											max="15" min="-30" step="1"
											>	
										</input>

								</div>
								<div class="col-xs-2" id="ambienceBtn2Div">

									<button 
										id="ambienceBtns"
										:class="ambience2Class"
										@click="ambience2Func"
										> <i :class="ambience2Icon" style="color:white"></i>
										FIREPLACE
										</button>

										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance2RangerClass"
											v-model="ambience2Vol"
											:="ambienceMixing"
											max="15" min="-30" step="1"
											> 				
										</input>

								</div>
								<div class="col-xs-2" id="ambienceBtn3Div">

									<button 
										id="ambienceBtns"
										:class="ambience3Class"
										@click="ambience3Func"
										> <i :class="ambience3Icon" style="color:white"></i>
										WINTER
										</button>
										
										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance3RangerClass"
											v-model="ambience3Vol"
											:="ambienceMixing"
											max="15" min="-30" step="1"
											>
										</input>
								</div>
								<div class="col-xs-2" id="ambienceBtn4Div">

									<button 
										id="ambienceBtns"
										:class="ambience4Class"
										@click="ambience4Func"
										> <i :class="ambience4Icon" style="color:white"></i>
										NOISEMAKER
										</button>
										
										<input 
											id="ambienceSlider"
											type="range"
											:class="ambiance4RangerClass"
											v-model="ambience4Vol"
											:="ambienceMixing"
											max="10" min="-30" step="1"
											>
										</input>
								</div>

								<div class="col-xs-2" id="ambienceHornDiv">

									<button 
										id="ambienceBtns"
										:class="hornClass"
										@click="hornBlow"
										> <i 
											:class="hornStartStopIcon" 
											v-bind:style="{'color': hornTrigger ? stopColor : playColor }"></i>
										HORN
										</button>
										
										
								</div>

								<div class="col-xs-2" id="ambienceNoiseDiv">

									<button 
										id="ambienceBtns"
										:class="noisemakerClass"
										@click="noiseMakerFunc"
										> <i 
											:class="noisemakerStartStopIcon" 
											v-bind:style="{'color': noisemakerTrigger ? stopColor : playColor }"></i>
										CLACKER
										</button>
										
										
								</div>



								
								<!-- <div class="col-xs-2 offset-xs-8">

									<button 
										id="ambienceBtns"
										:class="ambience5Class"
										@click="ambience5Func"
										> <i :class="ambience5Icon" style="color:white"></i>
										Beach Vibes
										</button>
										<br>
										<br>
										<input 
											type="range"
											class="ambianceRanger"
											v-model="ambience5Vol"
											:="ambienceMixing"
											max="5" min="-30" step="1"
											>
										</input>
								</div> -->
								<!-- <div class="col-xs-2 offset-xs-10">		

									<button 
										id="ambienceBtns"
										:class="ambience6Class"
										@click="ambience6Func"
										> <i :class="ambience6Icon" style="color:white"></i>
										Water Row
										</button>
										<br>
										<br>
										<input 
											type="range"
											class="ambianceRanger"
											v-model="ambience6Vol"
											:="ambienceMixing"
											max="5" min="-30" step="1"
											>
										</input>
								</div> -->
							</div>
						</div>
<!-- DUMMY DIV                -->
		<!-- <div id="mattsDen" class="alert alert-info">
		
			<h2> Matt's Dev Den </h2>

			<h4>screenX: {{screenWidth}}   &  
			screenY: {{screenHeight}}</h4>

			<h4>SunX: {{playSunDraggieWidth}} &
			SunY: {{playSunDraggieHeight}}</h4>

			<h4>about1X: {{aboutDraggieWidth}} &
			about1Y: {{aboutDraggieHeight}} 
			<br>
			about2X: {{about2DraggieWidth}} &
			about2Y: {{about2DraggieHeight}}
			<br>
			about3X: {{about3DraggieWidth}} &
			about3Y: {{about3DraggieHeight}}</h4>

			<h4> sliderMin: {{sliderMin}}</h4>
			<h4> voice1Radius: {{voice1Radius}}</h4>
		</div> -->
	</div>
</template>

<script>
import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js'
import Tone from '../../node_modules/Tone/build/Tone.min.js'
import Draggabilly from 'draggabilly';
// import Vue2TouchEvents from 'vue2-touch-events'

	export default {
data: () => ({
		//CONTROLS
			reverbChecker: undefined,
			loadingBoolean: true,
			sunDisableBoolean: false,
			userMobile:   Boolean,
			mailingListBtn:     false,
			textTiming: 		500,
			startStopTrigger:   true,
			playColor: 			 "#F0CB50",	
			stopColor:           "#1E9BFC",
		//SCREEN DIMENSIONS
			screenHeight: 				undefined,
			screenWidth: 				undefined,
			ogWidth: 					undefined,
		//SHOW AND HIDE	
			WelcomeText:           		true,	
			discoLogo: 					true,
			Subtitle:           		true,
			showMissionControl:         false,
			showAmbiances:              false,

			missionTrigger:             false,
			ambianceTrigger:            false,
			helpTrigger:                false,
			promptTrigger:              true,
			bellBoolean:                false,
			hornTrigger:                false,
			noisemakerTrigger:                false,
			horn1Playing:  				true,
			horn2Playing:  				false,
		//DRAGGIES
			masterTiming:               0.02,
			sliderMin:                  0,
			sliderMax:                  0,
			reverbColoringVar:          undefined,
			allowAllTogether:           false,
		//REVERB DRAGGIE
			reverbDraggie:              undefined,
			reverbDraggieHeight: 		undefined,
			reverbDraggieWidth: 		undefined,
			reverbRadiusX:              200,
			reverbRadiusY: 				200,

			reverbRadius: 				400,

			reverbcosVar: 				1,
			reverbsinVar: 				1,
			reverbTiming:               0.006,
			reverbSize:                 1, 

			reverbColorState1:          true,
			reverbColorState2:          false,
			reverbColorState3:          false,
			reverbColorState4:          false,

			reverbVolume20:             false,
			reverbVolume19:             false,
			reverbVolume18:             false,
			reverbVolume17:             false,
			reverbVolume16:             false,
			reverbVolume15:             false,
			reverbVolume14:             false,
			reverbVolume13:             false,
			reverbVolume12:             false,
			reverbVolume10:             false,
			reverbVolume9:              false,
			reverbVolume8:              false,
			reverbVolume7:              false,
			reverbVolume6:              false,
			reverbVolume5:              false,
			reverbVolume4:              false,
			reverbVolume3:              false,
			reverbVolume2:              false,
			reverbVolume1:              false,
		//VOICE 1 DRAGGIE
			voice1Draggie:            	undefined,
			voice1DraggieHeight: 		undefined,
			voice1DraggieWidth: 		undefined,
			voice1ID:         			undefined,
			voice1IDLogging:         	undefined,
			voice1RadiusX:              200,
			voice1RadiusY: 				200,
			voice1Radius: 				200,
			voice1cosVar: 				1,
			voice1sinVar: 				1,
			voice1Timing:               0.006,
			voice1Volume:               undefined,
			voice1State:                5,
			voice1CurrentInstrument:    "",

			voice1ColorState1:          true,
			voice1ColorState2:          false,
			voice1ColorState3:          false,
			voice1ColorState4:          false,

			voice1Volume20:             false,
			voice1Volume19:             false,
			voice1Volume18:             false,
			voice1Volume17:             false,
			voice1Volume16:             false,
			voice1Volume15:             false,
			voice1Volume14:             false,
			voice1Volume13:             false,
			voice1Volume12:             false,
			voice1Volume10:             false,
			voice1Volume9:              false,
			voice1Volume8:              false,
			voice1Volume7:              false,
			voice1Volume6:              false,
			voice1Volume5:              false,
			voice1Volume4:              false,
			voice1Volume3:              false,
			voice1Volume2:              false,
			voice1Volume1:              false,
		//VOICE 2 DRAGGIE
			voice2Draggie:           	undefined,
			voice2DraggieHeight: 		undefined,
			voice2DraggieWidth: 		undefined,
			voice2ID: 					undefined,
			voice2IDLogging:         	undefined,
			voice2RadiusX:              250,
			voice2RadiusY: 				250,
			voice2Radius: 				250,
			voice2cosVar: 				2.6,
			voice2sinVar: 				2.6,
			voice2Timing:               0.006,
			voice2Volume:               undefined,
			voice2State:                5,
			voice2CurrentInstrument:    "",

			voice2ColorState1:          true,
			voice2ColorState2:          false,
			voice2ColorState3:          false,
			voice2ColorState4:          false,

			voice2Volume20:             false,
			voice2Volume19:             false,
			voice2Volume18:             false,
			voice2Volume17:             false,
			voice2Volume16:             false,
			voice2Volume15:             false,
			voice2Volume14:             false,
			voice2Volume13:             false,
			voice2Volume12:             false,
			voice2Volume10:             false,
			voice2Volume9:              false,
			voice2Volume8:              false,
			voice2Volume7:              false,
			voice2Volume6:              false,
			voice2Volume5:              false,
			voice2Volume4:              false,
			voice2Volume3:              false,
			voice2Volume2:              false,
			voice2Volume1:              false,
		//VOICE 3 DRAGGIE
			voice3Draggie:            	undefined,
			voice3DraggieHeight: 		undefined,
			voice3DraggieWidth: 		undefined,
			voice3ID:  					undefined,
			voice3IDLogging:         	undefined,
			voice3RadiusX:              300,
			voice3RadiusY: 				300,
			voice3Radius: 				300,
			voice3cosVar: 				4.2,
			voice3sinVar: 				4.2,
			voice3Timing:               0.006,
			voice3Volume:               undefined,
			voice3State:                5,
			voice3CurrentInstrument:    "",

			voice3ColorState1:          true,
			voice3ColorState2:          false,
			voice3ColorState3:          false,
			voice3ColorState4:          false,

			voice3Volume20:             false,
			voice3Volume19:             false,
			voice3Volume18:             false,
			voice3Volume17:             false,
			voice3Volume16:             false,
			voice3Volume15:             false,
			voice3Volume14:             false,
			voice3Volume13:             false,
			voice3Volume12:             false,
			voice3Volume10:             false,
			voice3Volume9:              false,
			voice3Volume8:              false,
			voice3Volume7:              false,
			voice3Volume6:              false,
			voice3Volume5:              false,
			voice3Volume4:              false,
			voice3Volume3:              false,
			voice3Volume2:              false,
			voice3Volume1:              false,
		//VOICE 4 DRAGGIE
			voice4Draggie:          	undefined,
			voice4DraggieHeight: 		undefined,
			voice4DraggieWidth: 		undefined,
			voice4ID: 					undefined,
			voice4IDLogging:         	undefined,
			voice4RadiusX:              350,
			voice4RadiusY: 				350,
			voice4Radius:   			350,
			voice4RadiusMovementX:   	undefined,
			voice4RadiusMovementY:   	undefined,
			voice4cosVar: 				5.7,
			voice4sinVar: 				5.7,
			voice4Timing:               0.006,
			voice4Volume:               undefined,
			voice4State:                5,
			voice4CurrentInstrument:    "",

			voice4ColorState1:          true,
			voice4ColorState2:          false,
			voice4ColorState3:          false,
			voice4ColorState4:          false,

			voice4Volume20:             false,
			voice4Volume19:             false,
			voice4Volume18:             false,
			voice4Volume17:             false,
			voice4Volume16:             false,
			voice4Volume15:             false,
			voice4Volume14:             false,
			voice4Volume13:             false,
			voice4Volume12:             false,
			voice4Volume10:             false,
			voice4Volume9:              false,
			voice4Volume8:              false,
			voice4Volume7:              false,
			voice4Volume6:              false,
			voice4Volume5:              false,
			voice4Volume4:              false,
			voice4Volume3:              false,
			voice4Volume2:              false,
			voice4Volume1:              false,
		//PLAY SUN DRAGGIE
			playSunDraggie:   			undefined,
			playSunDraggieHeight: 		undefined,
			playSunDraggieWidth: 		undefined,
			playSunID: 					undefined,
			activeSun:               false,
		//ABOUT DRAGGIE
			aboutDraggie:   		 undefined,
			about2Draggie:   		 undefined,
			about3Draggie:   		 undefined,
			about4Draggie:   		 undefined,
		//VOICE BOOLEANS
			stringsVoice1Boolean:       false,
			stringsVoice2Boolean:       false,
			stringsVoice3Boolean:       false,
			stringsVoice4Boolean:       false,

			pianoVoice1Boolean:       false,
			pianoVoice2Boolean:       false,
			pianoVoice3Boolean:       false,
			pianoVoice4Boolean:       false,

			accordionVoice1Boolean:       false,
			accordionVoice2Boolean:       false,
			accordionVoice3Boolean:       false,
			accordionVoice4Boolean:       false,
			
			windsVoice1Boolean:       false,
			windsVoice2Boolean:       false,
			windsVoice3Boolean:       false,
			windsVoice4Boolean:       false,

			celestaVoice1Boolean:       false,
			celestaVoice2Boolean:       false,
			celestaVoice3Boolean:       false,
			celestaVoice4Boolean:       false,	
		//V-SHOWS
			showNavBar:         false,
			showSection: 		true,
			showHelp:         	false,
			showPrompt:         false,
			showMutePrompt:     false,
			showHorn:           true,
			voice1Div:          false,
			voice2Div:          false,
			voice3Div:        	false,
			voice4Div:        	false,
			playSunDiv:        	false,
			aboutDiv:           false,
			sunText:            "",
			sunText2:            "",
			sunLoad1: 			"Loading...",
			sunLoad2: 			"Please Wait",
			allTogetherSunText: "",
			whichHorn:          true,
		//AMBIENCE BOOLEANS
			ambience1Boolean:   false,
			ambience2Boolean:   false,
			ambience3Boolean:   false,
			ambience4Boolean:   false,
		//AMBIENCE DATA
			ambience1Vol:               0,
			ambience2Vol:               0,
			ambience3Vol:               0,
			ambience4Vol:               0,
			ambience1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.037650,
										"loopEnd"  : 11.287000,
			  							"volume": 4,
			  							}).toMaster(),
			ambience2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.039881,
										"loopEnd"  : 16.272173,
			  							"volume": 6,
			  							}).toMaster(),
			ambience3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.026550,
										"loopEnd"  : 15.34660,
			  							"volume": 6,
			  							}).toMaster(),
			ambience4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"loopStart"  : 0.039360,
										"loopEnd"  : 4.145510,
			  							"volume": 6,
			  							}).toMaster(),
		//WAVES TIMING
			// "loopStart"  : 0.038095,
			// "loopEnd"  : 18.466125,
		//VOICE AUDIO DATA
			horn: 						new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.046325,
										// "loopEnd"  : 42.79565,
			  							"volume": 2
			  							}).toMaster(),
			noisemaker: 				new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : false,
			  							"retrigger"  : true,
			  					// 		"loopStart"  : 0.025200,
										// "loopEnd"  : 42.79565,
			  							"volume": 0
			  							}).toMaster(),
			stringsVoice1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -2
			  							}),
			stringsVoice2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -2
			  							}),
			stringsVoice3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": 1
			  							}),
			stringsVoice4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": 0
			  							}),
			pianoVoice1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -4
			  							}),
			pianoVoice2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -5
			  							}),
			pianoVoice3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -4
			  							}),
			pianoVoice4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -4
			  							}),
			accordionVoice1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": 4
			  							}),
			accordionVoice2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume": 4
			  							}),
			accordionVoice3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": 4
			  							}),
			accordionVoice4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": 6
			  							}),
			windsVoice1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -2
			  							}),
			windsVoice2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -2
			  							}),
			windsVoice3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume": -2
			  							}),
			windsVoice4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume": -2
			  							}),
			celestaVoice1Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -6
			  							}),
			celestaVoice2Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
			  							"volume": -5
			  							}),
			celestaVoice3Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume" : -1
			  							}),
			celestaVoice4Player: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume" : -4
			  							}),
			allV1: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume" : -4
			  							}),
			allV2: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume" : -5
			  							}),
			allV3: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume" : -5
			  							}),
			allV4: 			new Tone.Player({
			  							"playbackRate" : 1,
			  							"loop" : true,
			  							"retrigger"  : false,
			  							"loopStart"  : 0.025200,
										"loopEnd"  : 42.79565,
										"volume" : -6
			  							}),
		//AUDIO ROUTING & EFFECTS
			voiceVolTracker1: 0,
			voiceVolTracker2: 0,
			voiceVolTracker3: 0,
			voiceVolTracker4: 0,

			masterVolume:     -2,

			voices1MasterVolume:      	new Tone.Volume(0),
			voices2MasterVolume:      	new Tone.Volume(0),
			voices3MasterVolume:      	new Tone.Volume(0),
			voices4MasterVolume:      	new Tone.Volume(0),

			allV1MasterVolume:      	new Tone.Volume(0),
			allV2MasterVolume:      	new Tone.Volume(0),
			allV3MasterVolume:      	new Tone.Volume(0),
			allV4MasterVolume:      	new Tone.Volume(0),

			masterVolumeSub:      		new Tone.Volume(0).toMaster(),	
			hornLoading:         		undefined,
			audioLoading: 				undefined,
			startAudioBoolean:    		true,
		}),
mounted(){
},
created(){
	setTimeout(this.mobileCheck, 50);
	setTimeout(this.initIntervals, 400);
	setTimeout(this.holidayLoading, 450);
	setTimeout(this.sliderRangeSet, 500);
	this.ogScreenSize();
	// this.audioLoading();
	// this.bufferLoading();
	this.hornLoadingFunc();
	//INITUAL AUDIO LEVELS
		this.stringsVoice1Player.mute = true;
		this.pianoVoice1Player.mute = true;
		this.accordionVoice1Player.mute = true;
		this.windsVoice1Player.mute = true;
		this.celestaVoice1Player.mute = true;
		this.stringsVoice2Player.mute = true;
		this.pianoVoice2Player.mute = true;
		this.accordionVoice2Player.mute = true;
		this.windsVoice2Player.mute = true;
		this.celestaVoice2Player.mute = true;
		this.stringsVoice3Player.mute = true;
		this.pianoVoice3Player.mute = true;
		this.accordionVoice3Player.mute = true;
		this.windsVoice3Player.mute = true;
		this.celestaVoice3Player.mute = true;
		this.stringsVoice4Player.mute = true;
		this.pianoVoice4Player.mute = true;
		this.accordionVoice4Player.mute = true;
		this.windsVoice4Player.mute = true;
		this.celestaVoice4Player.mute = true;

		this.allV1.mute = true;
		this.allV2.mute = true;
		this.allV3.mute = true;
		this.allV4.mute = true;
	},

computed:{
	//SHOW AND HIDE CLASS CHANGES
					harmonyClass(){
						return{
							"btn btn-transparent": this.missionTrigger,
							"btn btn-info": !this.missionTrigger,
						}
					},
					ambianceClass(){
						return{
							"btn btn-transparent": this.ambianceTrigger,
							"btn btn-info": !this.ambianceTrigger,
						}
					},
					helpClass(){
						return{
							"btn btn-transparent": this.helpTrigger,
							"btn btn-info": !this.helpTrigger,
						}
					},
					promptButtonClass(){
						return{
							"btn btn-transparent": this.promptTrigger,
							"btn btn-info": !this.promptTrigger,
						}	
					},
					mailingListBtnClass(){
						return{
							"btn btn-transparent": this.mailingListBtn,
							"btn btn-info": !this.mailingListBtn,
						}	
					},
					hornClass(){
						return{
							"btn btn-hornButtonClass": this.hornTrigger,
							"btn btn-hornButtonClass2": !this.hornTrigger,
						}
					},
					noisemakerClass(){
						return{
							"btn btn-hornButtonClass": this.noisemakerTrigger,
							"btn btn-hornButtonClass2": !this.noisemakerTrigger,
						}
					},
					horn1Class(){
						return{
							"btn btn-transparent": this.horn1Playing,
							"btn btn-info": !this.horn1Playing,
						}
					},
					horn2Class(){
						return{
							"btn btn-info": this.horn1Playing,
							"btn btn-transparent": !this.horn1Playing,
						}
					},
	//AMBIENCE CLASS CHANGES
					ambience1Class(){
						return{
							"btn btn-success": this.ambience1Boolean,
							"btn btn-danger": !this.ambience1Boolean,
						}
					},
					ambience2Class(){
						return{
							"btn btn-success": this.ambience2Boolean,
							"btn btn-danger": !this.ambience2Boolean,
						}
					},
					ambience3Class(){
						return{
							"btn btn-success": this.ambience3Boolean,
							"btn btn-danger": !this.ambience3Boolean,
						}
					},
					ambience4Class(){
						return{
							"btn btn-success": this.ambience4Boolean,
							"btn btn-danger": !this.ambience4Boolean,
						}
					},
	//AMBIENCE ICON CSS
					bellSlash(){
						return{
							"fa fa-bell fa-2x": this.bellBoolean,
							"fa fa-bell-slash fa-2x": !this.bellBoolean
							}
					},
					ambience1Icon(){
						return {
							"fa fa-toggle-on": this.ambience1Boolean,
							"fa fa-toggle-off": !this.ambience1Boolean
						}
					},
					ambience2Icon(){
						return {
							"fa fa-toggle-on": this.ambience2Boolean,
							"fa fa-toggle-off": !this.ambience2Boolean
						}
					},
					ambience3Icon(){
						return {
							"fa fa-toggle-on": this.ambience3Boolean,
							"fa fa-toggle-off": !this.ambience3Boolean
						}
					},
					ambience4Icon(){
						return {
							"fa fa-toggle-on": this.ambience4Boolean,
							"fa fa-toggle-off": !this.ambience4Boolean
						}
					},
					ambience5Icon(){
						return {
							"fa fa-toggle-on": this.ambience5Boolean,
							"fa fa-toggle-off": !this.ambience5Boolean
						}
					},
					ambience6Icon(){
						return {
							"fa fa-toggle-on": this.ambience6Boolean,
							"fa fa-toggle-off": !this.ambience6Boolean
						}
					},												
	//CSS START AND STOP CLASS CHANGES (PLAY BUTTON)
					startStopIcon(){
						return {
							"fa fa-stop": this.startStopTrigger,
							"fa fa-play": !this.startStopTrigger,
						}
					},
					hornStartStopIcon(){
						return {
							"fa fa-dot-circle-o": this.hornTrigger,
							"fa fa-circle-o": !this.hornTrigger,
						}

						// return {
						// 	"fa fa-circle-o-notch fa-counter-spin": this.hornTrigger,
						// 	"fa fa-circle-o-notch": !this.hornTrigger,
						// }
					},
					noisemakerStartStopIcon(){
						return {
							"fa fa-dot-circle-o": this.noisemakerTrigger,
							"fa fa-circle-o": !this.noisemakerTrigger,
						}
					},
					startStopClass(){
						return {
							"btn btn-danger": this.startStopTrigger,
							"btn btn-success": !this.startStopTrigger
						}
					},
	//VOICE BUBBLE CLASS CHANGES
					voice1DivClass(){
					if (this.voice1Radius <= this.sliderMin){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = true;
						this.voices1MasterVolume.volume.value = 0;
						this.allV1MasterVolume.volume.value = 0;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 2)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = true;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -2;
						this.allV1MasterVolume.volume.value = -2;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 3)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = true;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -4;
						this.allV1MasterVolume.volume.value = -4;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 4)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = true;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -6;
						this.allV1MasterVolume.volume.value = -6;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 5)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = true;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -8;
						this.allV1MasterVolume.volume.value = -8;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 6)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = true;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -10;
						this.allV1MasterVolume.volume.value = -10;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 7)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = true;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -12;
						this.allV1MasterVolume.volume.value = -12;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 8)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = true;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -14;
						this.allV1MasterVolume.volume.value = -14;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 9)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = true;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -16;
						this.allV1MasterVolume.volume.value = -16;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 10)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = true;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -18;
						this.allV1MasterVolume.volume.value = -18;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 11)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = true;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -20;
						this.allV1MasterVolume.volume.value = -20;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 12)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = true;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -22;
						this.allV1MasterVolume.volume.value = -22;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 13)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = true;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -24;
						this.allV1MasterVolume.volume.value = -24;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 14)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = true;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -26;
						this.allV1MasterVolume.volume.value = -26;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 15)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = true;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -30;
						this.allV1MasterVolume.volume.value = -30;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 16)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = true;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -36;
						this.allV1MasterVolume.volume.value = -36;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 17)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = true;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -44;
						this.allV1MasterVolume.volume.value = -44;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 18)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = false;
						this.voice1Volume18 = true;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -50;
						this.allV1MasterVolume.volume.value = -50;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 19)))){
						this.voice1Volume20 = false;
						this.voice1Volume19 = true;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -55;
						this.allV1MasterVolume.volume.value = -55;
					} else if (this.voice1Radius < ((this.sliderMin + (this.reverbColoringVar * 20)))){
						this.voice1Volume20 = true;
						this.voice1Volume19 = false;
						this.voice1Volume18 = false;
						this.voice1Volume17 = false;
						this.voice1Volume16 = false;
						this.voice1Volume15 = false;
						this.voice1Volume14 = false;
						this.voice1Volume13 = false;
						this.voice1Volume12 = false;
						this.voice1Volume11 = false;
						this.voice1Volume10 = false;
						this.voice1Volume9 = false;
						this.voice1Volume8 = false;
						this.voice1Volume7 = false;
						this.voice1Volume6 = false;
						this.voice1Volume5 = false;
						this.voice1Volume4 = false;
						this.voice1Volume3 = false;
						this.voice1Volume2 = false;
						this.voice1Volume1 = false;
						this.voices1MasterVolume.volume.value = -60;
						this.allV1MasterVolume.volume.value = -60;
					} 

					// if (this.voice1State == 5){
					// 	this.voice1ColorState1 = false;
					// 	this.voice1ColorState2 = false;
					// 	this.voice1ColorState3 = false;
					// 	this.voice1ColorState4 = false;
					// 	this.voice1ColorState5 = true;
					// } else if (this.voice1State == 4){
					// 	this.voice1ColorState1 = false;
					// 	this.voice1ColorState2 = false;
					// 	this.voice1ColorState3 = false;
					// 	this.voice1ColorState4 = true;
					// 	this.voice1ColorState5 = false;
					// } else if (this.voice1State == 3){
					// 	this.voice1ColorState1 = false;
					// 	this.voice1ColorState2 = false;
					// 	this.voice1ColorState3 = true;
					// 	this.voice1ColorState4 = false;
					// 	this.voice1ColorState5 = false;
					// } else if (this.voice1State == 2){
					// 	this.voice1ColorState1 = false;
					// 	this.voice1ColorState2 = true;
					// 	this.voice1ColorState3 = false;
					// 	this.voice1ColorState4 = false;
					// 	this.voice1ColorState5 = false;
					// } else if (this.voice1State == 1){
					// 	this.voice1ColorState1 = true;
					// 	this.voice1ColorState2 = false;
					// 	this.voice1ColorState3 = false;
					// 	this.voice1ColorState4 = false;
					// 	this.voice1ColorState5 = false;
					// }

					return{
						"voice1Sizing20": this.voice1Volume20,
						"voice1Sizing19": this.voice1Volume19,
						"voice1Sizing18": this.voice1Volume18,
						"voice1Sizing17": this.voice1Volume17,
						"voice1Sizing16": this.voice1Volume16,
						"voice1Sizing15": this.voice1Volume15,
						"voice1Sizing14": this.voice1Volume14,
						"voice1Sizing13": this.voice1Volume13,
						"voice1Sizing12": this.voice1Volume12,
						"voice1Sizing11": this.voice1Volume11,
						"voice1Sizing10": this.voice1Volume10,
						"voice1Sizing9": this.voice1Volume9,
						"voice1Sizing8": this.voice1Volume8,
						"voice1Sizing7": this.voice1Volume7,
						"voice1Sizing6": this.voice1Volume6,
						"voice1Sizing5": this.voice1Volume5,
						"voice1Sizing4": this.voice1Volume4,
						"voice1Sizing3": this.voice1Volume3,
						"voice1Sizing2": this.voice1Volume2,
						"voice1Sizing1": this.voice1Volume1
					}

					

					// return{
						
					// }

					},
					voice2DivClass(){
					if (this.voice2Radius <= this.sliderMin){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = true;
						this.voices2MasterVolume.volume.value = 0;
						this.allV2MasterVolume.volume.value = 0;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 2)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = true;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -2;
						this.allV2MasterVolume.volume.value = -2;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 3)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = true;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -4;
						this.allV2MasterVolume.volume.value = -4;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 4)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = true;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -6;
						this.allV2MasterVolume.volume.value = -6;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 5)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = true;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -8;
						this.allV2MasterVolume.volume.value = -8;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 6)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = true;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -10;
						this.allV2MasterVolume.volume.value = -10;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 7)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = true;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -12;
						this.allV2MasterVolume.volume.value = -12;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 8)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = true;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -14;
						this.allV2MasterVolume.volume.value = -14;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 9)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = true;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -16;
						this.allV2MasterVolume.volume.value = -16;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 10)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = true;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -18;
						this.allV2MasterVolume.volume.value = -18;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 11)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = true;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -20;
						this.allV2MasterVolume.volume.value = -20;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 12)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = true;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -22;
						this.allV2MasterVolume.volume.value = -22;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 13)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = true;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -24;
						this.allV2MasterVolume.volume.value = -24;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 14)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = true;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -26;
						this.allV2MasterVolume.volume.value = -26;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 15)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = true;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -30;
						this.allV2MasterVolume.volume.value = -30;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 16)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = true;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -36;
						this.allV2MasterVolume.volume.value = -36;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 17)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = true;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -44;
						this.allV2MasterVolume.volume.value = -44;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 18)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = false;
						this.voice2Volume18 = true;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -50;
						this.allV2MasterVolume.volume.value = -50;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 19)))){
						this.voice2Volume20 = false;
						this.voice2Volume19 = true;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -55;
						this.allV2MasterVolume.volume.value = -55;
					} else if (this.voice2Radius < ((this.sliderMin + (this.reverbColoringVar * 20)))){
						this.voice2Volume20 = true;
						this.voice2Volume19 = false;
						this.voice2Volume18 = false;
						this.voice2Volume17 = false;
						this.voice2Volume16 = false;
						this.voice2Volume15 = false;
						this.voice2Volume14 = false;
						this.voice2Volume13 = false;
						this.voice2Volume12 = false;
						this.voice2Volume11 = false;
						this.voice2Volume10 = false;
						this.voice2Volume9 = false;
						this.voice2Volume8 = false;
						this.voice2Volume7 = false;
						this.voice2Volume6 = false;
						this.voice2Volume5 = false;
						this.voice2Volume4 = false;
						this.voice2Volume3 = false;
						this.voice2Volume2 = false;
						this.voice2Volume1 = false;
						this.voices2MasterVolume.volume.value = -60;
						this.allV2MasterVolume.volume.value = -60;
					} 

					// if (this.voice2State == 5){
					// 	this.voice2ColorState1 = false;
					// 	this.voice2ColorState2 = false;
					// 	this.voice2ColorState3 = false;
					// 	this.voice2ColorState4 = false;
					// 	this.voice2ColorState5 = true;
					// } else if (this.voice2State == 4){
					// 	this.voice2ColorState1 = false;
					// 	this.voice2ColorState2 = false;
					// 	this.voice2ColorState3 = false;
					// 	this.voice2ColorState4 = true;
					// 	this.voice2ColorState5 = false;
					// } else if (this.voice2State == 3){
					// 	this.voice2ColorState1 = false;
					// 	this.voice2ColorState2 = false;
					// 	this.voice2ColorState3 = true;
					// 	this.voice2ColorState4 = false;
					// 	this.voice2ColorState5 = false;
					// } else if (this.voice2State == 2){
					// 	this.voice2ColorState1 = false;
					// 	this.voice2ColorState2 = true;
					// 	this.voice2ColorState3 = false;
					// 	this.voice2ColorState4 = false;
					// 	this.voice2ColorState5 = false;
					// } else if (this.voice2State == 1){
					// 	this.voice2ColorState1 = true;
					// 	this.voice2ColorState2 = false;
					// 	this.voice2ColorState3 = false;
					// 	this.voice2ColorState4 = false;
					// 	this.voice2ColorState5 = false;
					// }

					return{
						"voice2Sizing20": this.voice2Volume20,
						"voice2Sizing19": this.voice2Volume19,
						"voice2Sizing18": this.voice2Volume18,
						"voice2Sizing17": this.voice2Volume17,
						"voice2Sizing16": this.voice2Volume16,
						"voice2Sizing15": this.voice2Volume15,
						"voice2Sizing14": this.voice2Volume14,
						"voice2Sizing13": this.voice2Volume13,
						"voice2Sizing12": this.voice2Volume12,
						"voice2Sizing11": this.voice2Volume11,
						"voice2Sizing10": this.voice2Volume10,
						"voice2Sizing9": this.voice2Volume9,
						"voice2Sizing8": this.voice2Volume8,
						"voice2Sizing7": this.voice2Volume7,
						"voice2Sizing6": this.voice2Volume6,
						"voice2Sizing5": this.voice2Volume5,
						"voice2Sizing4": this.voice2Volume4,
						"voice2Sizing3": this.voice2Volume3,
						"voice2Sizing2": this.voice2Volume2,
						"voice2Sizing1": this.voice2Volume1
					}
					},
					voice3DivClass(){
					if (this.voice3Radius <= this.sliderMin){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = true;
						this.voices3MasterVolume.volume.value = 0;
						this.allV3MasterVolume.volume.value = 0;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 2)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = true;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -2;
						this.allV3MasterVolume.volume.value = -2;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 3)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = true;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -4;
						this.allV3MasterVolume.volume.value = -4;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 4)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = true;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -6;
						this.allV3MasterVolume.volume.value = -6;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 5)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = true;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -8;
						this.allV3MasterVolume.volume.value = -8;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 6)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = true;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -10;
						this.allV3MasterVolume.volume.value = -10;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 7)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = true;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -12;
						this.allV3MasterVolume.volume.value = -12;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 8)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = true;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -14;
						this.allV3MasterVolume.volume.value = -14;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 9)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = true;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -16;
						this.allV3MasterVolume.volume.value = -16;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 10)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = true;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -18;
						this.allV3MasterVolume.volume.value = -18;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 11)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = true;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -20;
						this.allV3MasterVolume.volume.value = -20;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 12)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = true;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -22;
						this.allV3MasterVolume.volume.value = -22;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 13)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = true;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -24;
						this.allV3MasterVolume.volume.value = -24;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 14)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = true;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -26;
						this.allV3MasterVolume.volume.value = -26;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 15)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = true;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -30;
						this.allV3MasterVolume.volume.value = -30;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 16)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = true;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -36;
						this.allV3MasterVolume.volume.value = -36;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 17)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = true;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -44;
						this.allV3MasterVolume.volume.value = -44;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 18)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = false;
						this.voice3Volume18 = true;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -50;
						this.allV3MasterVolume.volume.value = -50;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 19)))){
						this.voice3Volume20 = false;
						this.voice3Volume19 = true;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -55;
						this.allV3MasterVolume.volume.value = -55;
					} else if (this.voice3Radius < ((this.sliderMin + (this.reverbColoringVar * 20)))){
						this.voice3Volume20 = true;
						this.voice3Volume19 = false;
						this.voice3Volume18 = false;
						this.voice3Volume17 = false;
						this.voice3Volume16 = false;
						this.voice3Volume15 = false;
						this.voice3Volume14 = false;
						this.voice3Volume13 = false;
						this.voice3Volume12 = false;
						this.voice3Volume11 = false;
						this.voice3Volume10 = false;
						this.voice3Volume9 = false;
						this.voice3Volume8 = false;
						this.voice3Volume7 = false;
						this.voice3Volume6 = false;
						this.voice3Volume5 = false;
						this.voice3Volume4 = false;
						this.voice3Volume3 = false;
						this.voice3Volume2 = false;
						this.voice3Volume1 = false;
						this.voices3MasterVolume.volume.value = -60;
						this.allV3MasterVolume.volume.value = -60;
					} 

					// if (this.voice3State == 5){
					// 	this.voice3ColorState1 = false;
					// 	this.voice3ColorState2 = false;
					// 	this.voice3ColorState3 = false;
					// 	this.voice3ColorState4 = false;
					// 	this.voice3ColorState5 = true;
					// } else if (this.voice3State == 4){
					// 	this.voice3ColorState1 = false;
					// 	this.voice3ColorState2 = false;
					// 	this.voice3ColorState3 = false;
					// 	this.voice3ColorState4 = true;
					// 	this.voice3ColorState5 = false;
					// } else if (this.voice3State == 3){
					// 	this.voice3ColorState1 = false;
					// 	this.voice3ColorState2 = false;
					// 	this.voice3ColorState3 = true;
					// 	this.voice3ColorState4 = false;
					// 	this.voice3ColorState5 = false;
					// } else if (this.voice3State == 2){
					// 	this.voice3ColorState1 = false;
					// 	this.voice3ColorState2 = true;
					// 	this.voice3ColorState3 = false;
					// 	this.voice3ColorState4 = false;
					// 	this.voice3ColorState5 = false;
					// } else if (this.voice3State == 1){
					// 	this.voice3ColorState1 = true;
					// 	this.voice3ColorState2 = false;
					// 	this.voice3ColorState3 = false;
					// 	this.voice3ColorState4 = false;
					// 	this.voice3ColorState5 = false;
					// }

					return{
						"voice3Sizing20": this.voice3Volume20,
						"voice3Sizing19": this.voice3Volume19,
						"voice3Sizing18": this.voice3Volume18,
						"voice3Sizing17": this.voice3Volume17,
						"voice3Sizing16": this.voice3Volume16,
						"voice3Sizing15": this.voice3Volume15,
						"voice3Sizing14": this.voice3Volume14,
						"voice3Sizing13": this.voice3Volume13,
						"voice3Sizing12": this.voice3Volume12,
						"voice3Sizing11": this.voice3Volume11,
						"voice3Sizing10": this.voice3Volume10,
						"voice3Sizing9": this.voice3Volume9,
						"voice3Sizing8": this.voice3Volume8,
						"voice3Sizing7": this.voice3Volume7,
						"voice3Sizing6": this.voice3Volume6,
						"voice3Sizing5": this.voice3Volume5,
						"voice3Sizing4": this.voice3Volume4,
						"voice3Sizing3": this.voice3Volume3,
						"voice3Sizing2": this.voice3Volume2,
						"voice3Sizing1": this.voice3Volume1
					}
					},
					voice4DivClass(){
					if (this.voice4Radius <= this.sliderMin){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = true;
						this.voices4MasterVolume.volume.value = 0;
						this.allV4MasterVolume.volume.value = 0;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 2)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = true;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -2;
						this.allV4MasterVolume.volume.value = -2;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 3)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = true;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -4;
						this.allV4MasterVolume.volume.value = -4;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 4)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = true;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -6;
						this.allV4MasterVolume.volume.value = -6;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 5)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = true;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -8;
						this.allV4MasterVolume.volume.value = -8;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 6)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = true;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -10;
						this.allV4MasterVolume.volume.value = -10;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 7)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = true;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -12;
						this.allV4MasterVolume.volume.value = -12;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 8)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = true;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -14;
						this.allV4MasterVolume.volume.value = -14;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 9)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = true;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -16;
						this.allV4MasterVolume.volume.value = -16;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 10)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = true;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -18;
						this.allV4MasterVolume.volume.value = -18;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 11)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = true;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -20;
						this.allV4MasterVolume.volume.value = -20;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 12)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = true;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -22;
						this.allV4MasterVolume.volume.value = -22;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 13)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = true;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -24;
						this.allV4MasterVolume.volume.value = -24;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 14)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = true;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -26;
						this.allV4MasterVolume.volume.value = -26;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 15)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = true;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -30;
						this.allV4MasterVolume.volume.value = -30;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 16)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = true;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -36;
						this.allV4MasterVolume.volume.value = -36;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 17)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = true;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -44;
						this.allV4MasterVolume.volume.value = -44;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 18)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = false;
						this.voice4Volume18 = true;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -50;
						this.allV4MasterVolume.volume.value = -50;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 19)))){
						this.voice4Volume20 = false;
						this.voice4Volume19 = true;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -55;
						this.allV4MasterVolume.volume.value = -55;
					} else if (this.voice4Radius < ((this.sliderMin + (this.reverbColoringVar * 20)))){
						this.voice4Volume20 = true;
						this.voice4Volume19 = false;
						this.voice4Volume18 = false;
						this.voice4Volume17 = false;
						this.voice4Volume16 = false;
						this.voice4Volume15 = false;
						this.voice4Volume14 = false;
						this.voice4Volume13 = false;
						this.voice4Volume12 = false;
						this.voice4Volume11 = false;
						this.voice4Volume10 = false;
						this.voice4Volume9 = false;
						this.voice4Volume8 = false;
						this.voice4Volume7 = false;
						this.voice4Volume6 = false;
						this.voice4Volume5 = false;
						this.voice4Volume4 = false;
						this.voice4Volume3 = false;
						this.voice4Volume2 = false;
						this.voice4Volume1 = false;
						this.voices4MasterVolume.volume.value = -60;
						this.allV4MasterVolume.volume.value = -60;
					} 

					// if (this.voice4State == 5){
					// 	this.voice4ColorState1 = false;
					// 	this.voice4ColorState2 = false;
					// 	this.voice4ColorState3 = false;
					// 	this.voice4ColorState4 = false;
					// 	this.voice4ColorState5 = true;
					// } else if (this.voice4State == 4){
					// 	this.voice4ColorState1 = false;
					// 	this.voice4ColorState2 = false;
					// 	this.voice4ColorState3 = false;
					// 	this.voice4ColorState4 = true;
					// 	this.voice4ColorState5 = false;
					// } else if (this.voice4State == 3){
					// 	this.voice4ColorState1 = false;
					// 	this.voice4ColorState2 = false;
					// 	this.voice4ColorState3 = true;
					// 	this.voice4ColorState4 = false;
					// 	this.voice4ColorState5 = false;
					// } else if (this.voice4State == 2){
					// 	this.voice4ColorState1 = false;
					// 	this.voice4ColorState2 = true;
					// 	this.voice4ColorState3 = false;
					// 	this.voice4ColorState4 = false;
					// 	this.voice4ColorState5 = false;
					// } else if (this.voice4State == 1){
					// 	this.voice4ColorState1 = true;
					// 	this.voice4ColorState2 = false;
					// 	this.voice4ColorState3 = false;
					// 	this.voice4ColorState4 = false;
					// 	this.voice4ColorState5 = false;
					// }

					return{
						"voice4Sizing20": this.voice4Volume20,
						"voice4Sizing19": this.voice4Volume19,
						"voice4Sizing18": this.voice4Volume18,
						"voice4Sizing17": this.voice4Volume17,
						"voice4Sizing16": this.voice4Volume16,
						"voice4Sizing15": this.voice4Volume15,
						"voice4Sizing14": this.voice4Volume14,
						"voice4Sizing13": this.voice4Volume13,
						"voice4Sizing12": this.voice4Volume12,
						"voice4Sizing11": this.voice4Volume11,
						"voice4Sizing10": this.voice4Volume10,
						"voice4Sizing9": this.voice4Volume9,
						"voice4Sizing8": this.voice4Volume8,
						"voice4Sizing7": this.voice4Volume7,
						"voice4Sizing6": this.voice4Volume6,
						"voice4Sizing5": this.voice4Volume5,
						"voice4Sizing4": this.voice4Volume4,
						"voice4Sizing3": this.voice4Volume3,
						"voice4Sizing2": this.voice4Volume2,
						"voice4Sizing1": this.voice4Volume1
					}
					},
	//AMBIANCE CLASS CHANGES
					ambiance1RangerClass(){
						return{
							"ambianceRangerPlay": this.ambience1Boolean,
							"ambianceRangerStop": !this.ambience1Boolean,
							}
					},
					ambiance2RangerClass(){
						return{
							"ambianceRangerPlay": this.ambience2Boolean,
							"ambianceRangerStop": !this.ambience2Boolean,
							}
					},
					ambiance3RangerClass(){
						return{
							"ambianceRangerPlay": this.ambience3Boolean,
							"ambianceRangerStop": !this.ambience3Boolean,
							}
					},
					ambiance4RangerClass(){
						return{
							"ambianceRangerPlay": this.ambience4Boolean,
							"ambianceRangerStop": !this.ambience4Boolean,
							}
					},
	//VOICE RADIUS WATCHING
		voice1RadiusFunc(){
			this.voice1RadiusX = this.voice1Radius;
			this.voice1RadiusY = this.voice1Radius;
		},
		voice2RadiusFunc(){
			this.voice2RadiusX = this.voice2Radius;
			this.voice2RadiusY = this.voice2Radius;
		},
		voice3RadiusFunc(){
			this.voice3RadiusX = this.voice3Radius;
			this.voice3RadiusY = this.voice3Radius;
		},
		voice4RadiusFunc(){
			this.voice4RadiusX = this.voice4Radius;
			this.voice4RadiusY = this.voice4Radius;
		},
		voice4RadiusFunc(){
			this.voice4RadiusX = this.voice4Radius;
			this.voice4RadiusY = this.voice4Radius;
		},
	//VOICE TIMING WATCHING
		masterTimingFunc(){
			this.voice1Timing = (this.masterTiming / 4);
			this.voice2Timing = (this.masterTiming / 4);
			this.voice3Timing = (this.masterTiming / 4);
			this.voice4Timing = (this.masterTiming / 4);
			this.reverbTiming = (this.masterTiming / 4);

			if (this.masterTiming <= 0.02){
				this.stringsVoice1Player.playbackRate = 1.0;
				this.stringsVoice2Player.playbackRate = 1.0;
				this.stringsVoice3Player.playbackRate = 1.0;
				this.stringsVoice4Player.playbackRate = 1.0;
				this.pianoVoice1Player.playbackRate = 1.0;
				this.pianoVoice2Player.playbackRate = 1.0;
				this.pianoVoice3Player.playbackRate = 1.0;
				this.pianoVoice4Player.playbackRate = 1.0;
				this.accordionVoice1Player.playbackRate = 1.0;
				this.accordionVoice2Player.playbackRate = 1.0;
				this.accordionVoice3Player.playbackRate = 1.0;
				this.accordionVoice4Player.playbackRate = 1.0;
				this.windsVoice1Player.playbackRate = 1.0;
				this.windsVoice2Player.playbackRate = 1.0;
				this.windsVoice3Player.playbackRate = 1.0;
				this.windsVoice4Player.playbackRate = 1.0;
				this.celestaVoice1Player.playbackRate = 1.0;
				this.celestaVoice2Player.playbackRate = 1.0;
				this.celestaVoice3Player.playbackRate = 1.0;
				this.celestaVoice4Player.playbackRate = 1.0;
				this.allV1.playbackRate = 1.0;
				this.allV2.playbackRate = 1.0;
				this.allV3.playbackRate = 1.0;
				this.allV4.playbackRate = 1.0;
			} else if (this.masterTiming <= 0.04){
				this.stringsVoice1Player.playbackRate = 1.15;
				this.stringsVoice2Player.playbackRate = 1.15;
				this.stringsVoice3Player.playbackRate = 1.15;
				this.stringsVoice4Player.playbackRate = 1.15;
				this.pianoVoice1Player.playbackRate = 1.15;
				this.pianoVoice2Player.playbackRate = 1.15;
				this.pianoVoice3Player.playbackRate = 1.15;
				this.pianoVoice4Player.playbackRate = 1.15;
				this.accordionVoice1Player.playbackRate = 1.15;
				this.accordionVoice2Player.playbackRate = 1.15;
				this.accordionVoice3Player.playbackRate = 1.15;
				this.accordionVoice4Player.playbackRate = 1.15;
				this.windsVoice1Player.playbackRate = 1.15;
				this.windsVoice2Player.playbackRate = 1.15;
				this.windsVoice3Player.playbackRate = 1.15;
				this.windsVoice4Player.playbackRate = 1.15;
				this.celestaVoice1Player.playbackRate = 1.15;
				this.celestaVoice2Player.playbackRate = 1.15;
				this.celestaVoice3Player.playbackRate = 1.15;
				this.celestaVoice4Player.playbackRate = 1.15;
				this.allV1.playbackRate = 1.15;
				this.allV2.playbackRate = 1.15;
				this.allV3.playbackRate = 1.15;
				this.allV4.playbackRate = 1.15;
			} else if (this.masterTiming <= 0.06){
				this.stringsVoice1Player.playbackRate = 1.3;
				this.stringsVoice2Player.playbackRate = 1.3;
				this.stringsVoice3Player.playbackRate = 1.3;
				this.stringsVoice4Player.playbackRate = 1.3;
				this.pianoVoice1Player.playbackRate = 1.3;
				this.pianoVoice2Player.playbackRate = 1.3;
				this.pianoVoice3Player.playbackRate = 1.3;
				this.pianoVoice4Player.playbackRate = 1.3;
				this.accordionVoice1Player.playbackRate = 1.3;
				this.accordionVoice2Player.playbackRate = 1.3;
				this.accordionVoice3Player.playbackRate = 1.3;
				this.accordionVoice4Player.playbackRate = 1.3;
				this.windsVoice1Player.playbackRate = 1.3;
				this.windsVoice2Player.playbackRate = 1.3;
				this.windsVoice3Player.playbackRate = 1.3;
				this.windsVoice4Player.playbackRate = 1.3;
				this.celestaVoice1Player.playbackRate = 1.3;
				this.celestaVoice2Player.playbackRate = 1.3;
				this.celestaVoice3Player.playbackRate = 1.3;
				this.celestaVoice4Player.playbackRate = 1.3;
				this.allV1.playbackRate = 1.3;
				this.allV2.playbackRate = 1.3;
				this.allV3.playbackRate = 1.3;
				this.allV4.playbackRate = 1.3;
			} else if (this.masterTiming <= 0.08){
				this.stringsVoice1Player.playbackRate = 1.45;
				this.stringsVoice2Player.playbackRate = 1.45;
				this.stringsVoice3Player.playbackRate = 1.45;
				this.stringsVoice4Player.playbackRate = 1.45;
				this.pianoVoice1Player.playbackRate = 1.45;
				this.pianoVoice2Player.playbackRate = 1.45;
				this.pianoVoice3Player.playbackRate = 1.45;
				this.pianoVoice4Player.playbackRate = 1.45;
				this.accordionVoice1Player.playbackRate = 1.45;
				this.accordionVoice2Player.playbackRate = 1.45;
				this.accordionVoice3Player.playbackRate = 1.45;
				this.accordionVoice4Player.playbackRate = 1.45;
				this.windsVoice1Player.playbackRate = 1.45;
				this.windsVoice2Player.playbackRate = 1.45;
				this.windsVoice3Player.playbackRate = 1.45;
				this.windsVoice4Player.playbackRate = 1.45;
				this.celestaVoice1Player.playbackRate = 1.45;
				this.celestaVoice2Player.playbackRate = 1.45;
				this.celestaVoice3Player.playbackRate = 1.45;
				this.celestaVoice4Player.playbackRate = 1.45;
				this.allV1.playbackRate = 1.45;
				this.allV2.playbackRate = 1.45;
				this.allV3.playbackRate = 1.45;
				this.allV4.playbackRate = 1.45;
			} else if (this.masterTiming <= 0.1){
				this.stringsVoice1Player.playbackRate = 1.6;
				this.stringsVoice2Player.playbackRate = 1.6;
				this.stringsVoice3Player.playbackRate = 1.6;
				this.stringsVoice4Player.playbackRate = 1.6;
				this.pianoVoice1Player.playbackRate = 1.6;
				this.pianoVoice2Player.playbackRate = 1.6;
				this.pianoVoice3Player.playbackRate = 1.6;
				this.pianoVoice4Player.playbackRate = 1.6;
				this.accordionVoice1Player.playbackRate = 1.6;
				this.accordionVoice2Player.playbackRate = 1.6;
				this.accordionVoice3Player.playbackRate = 1.6;
				this.accordionVoice4Player.playbackRate = 1.6;
				this.windsVoice1Player.playbackRate = 1.6;
				this.windsVoice2Player.playbackRate = 1.6;
				this.windsVoice3Player.playbackRate = 1.6;
				this.windsVoice4Player.playbackRate = 1.6;
				this.celestaVoice1Player.playbackRate = 1.6;
				this.celestaVoice2Player.playbackRate = 1.6;
				this.celestaVoice3Player.playbackRate = 1.6;
				this.celestaVoice4Player.playbackRate = 1.6;
				this.allV1.playbackRate = 1.6;
				this.allV2.playbackRate = 1.6;
				this.allV3.playbackRate = 1.6;
				this.allV4.playbackRate = 1.6;
			} else if (this.masterTiming <= 0.15){
				this.stringsVoice1Player.playbackRate = 1.75;
				this.stringsVoice2Player.playbackRate = 1.75;
				this.stringsVoice3Player.playbackRate = 1.75;
				this.stringsVoice4Player.playbackRate = 1.75;
				this.pianoVoice1Player.playbackRate = 1.75;
				this.pianoVoice2Player.playbackRate = 1.75;
				this.pianoVoice3Player.playbackRate = 1.75;
				this.pianoVoice4Player.playbackRate = 1.75;
				this.accordionVoice1Player.playbackRate = 1.75;
				this.accordionVoice2Player.playbackRate = 1.75;
				this.accordionVoice3Player.playbackRate = 1.75;
				this.accordionVoice4Player.playbackRate = 1.75;
				this.windsVoice1Player.playbackRate = 1.75;
				this.windsVoice2Player.playbackRate = 1.75;
				this.windsVoice3Player.playbackRate = 1.75;
				this.windsVoice4Player.playbackRate = 1.75;
				this.celestaVoice1Player.playbackRate = 1.75;
				this.celestaVoice2Player.playbackRate = 1.75;
				this.celestaVoice3Player.playbackRate = 1.75;
				this.celestaVoice4Player.playbackRate = 1.75;
				this.allV1.playbackRate = 1.75;
				this.allV2.playbackRate = 1.75;
				this.allV3.playbackRate = 1.75;
				this.allV4.playbackRate = 1.75;
			} else if (this.masterTiming <= 0.1){
				this.stringsVoice1Player.playbackRate = 2.0;
				this.stringsVoice2Player.playbackRate = 2.0;
				this.stringsVoice3Player.playbackRate = 2.0;
				this.stringsVoice4Player.playbackRate = 2.0;
				this.pianoVoice1Player.playbackRate = 2.0;
				this.pianoVoice2Player.playbackRate = 2.0;
				this.pianoVoice3Player.playbackRate = 2.0;
				this.pianoVoice4Player.playbackRate = 2.0;
				this.accordionVoice1Player.playbackRate = 2.0;
				this.accordionVoice2Player.playbackRate = 2.0;
				this.accordionVoice3Player.playbackRate = 2.0;
				this.accordionVoice4Player.playbackRate = 2.0;
				this.windsVoice1Player.playbackRate = 2.0;
				this.windsVoice2Player.playbackRate = 2.0;
				this.windsVoice3Player.playbackRate = 2.0;
				this.windsVoice4Player.playbackRate = 2.0;
				this.celestaVoice1Player.playbackRate = 2.0;
				this.celestaVoice2Player.playbackRate = 2.0;
				this.celestaVoice3Player.playbackRate = 2.0;
				this.celestaVoice4Player.playbackRate = 2.0;
				this.allV1.playbackRate = 2.0;
				this.allV2.playbackRate = 2.0;
				this.allV3.playbackRate = 2.0;
				this.allV4.playbackRate = 2.0;
			} 
		},
	//AUDIO MIXING
		ambienceMixing(){
				this.ambience1Player.volume.value = this.ambience1Vol;
				this.ambience2Player.volume.value = this.ambience2Vol;
				this.ambience3Player.volume.value = this.ambience3Vol;
				this.ambience4Player.volume.value = this.ambience4Vol;
				// this.ambience5Player.volume.value = this.ambience5Vol;
				// this.ambience6Player.volume.value = this.ambience6Vol;
		},
		masterVolumeMixing(){
				this.masterVolumeSub.volume.value = this.masterVolume;
		},
	},
methods: {
	startAudio(){
				StartAudioContext(Tone.context, "#ambienceBtns");
				},
	//MOBILE CHECK AND INTERVAL SETTING
		mobileCheck(){
			let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	            if (isMobile) 
	            { 
	            	this.userMobile = true;
	            	this.showMutePrompt = true;
	            	console.log('%c Mobile App Created by Matt McCorkle ' , 'background: black; color: gold');
	            } else {
	            	this.userMobile = false;
	            	console.log('%c Desktop App Created by Matt McCorkle ' , 'background: black; color: gold');
	            }
		},
		initIntervals(){
			setInterval(this.coordLog, 60);	 
			setInterval(this.screenSizing, 60);
		},
	//MAIN SHOW AND HIDE
		harmonyMixingPane(){
			this.missionTrigger = !this.missionTrigger;
			if (this.missionTrigger === true){
					this.showMissionControl = true;

					this.showAmbiances = false;
					this.ambianceTrigger = false;
					this.showHelpOverlay = false;
					this.helpTrigger = false;
					this.voice1Div = true;
					this.voice2Div = true;
					this.voice3Div = true;
					this.voice4Div = true;

					this.playSunDiv = true;
					this.aboutDiv = false;

					this.showPrompt = false;
			} else if (this.missionTrigger === false){
					this.showMissionControl = false;

			}
		},
		ambianceMixingPane(){
			this.ambianceTrigger = !this.ambianceTrigger;
			if (this.ambianceTrigger === true){
					this.showAmbiances = true;

					this.showMissionControl = false;
					this.missionTrigger = false;
					this.showHelpOverlay = false;
					this.helpTrigger = false;
					this.voice1Div = true;
					this.voice2Div = true;
					this.voice3Div = true;
					this.voice4Div = true;

					this.playSunDiv = true;
					this.aboutDiv = false;

					this.showPrompt = false;

			} else if (this.ambianceTrigger === false){
					this.showAmbiances = false;
			}
		},
		goToHelp(){
					this.showHelpOverlay = !this.showHelpOverlay;
					this.helpTrigger = !this.helpTrigger

					if (this.showHelpOverlay === true){
						// this.aboutID = setInterval(this.aboutMovement, 60);	
						// this.about2ID = setInterval(this.about2Movement, 60);	
						
						this.voice1Div = false;
						this.voice2Div = false;
						this.voice3Div = false;
						this.voice4Div = false;

						this.showMissionControl = false;
						this.missionTrigger = false;

						this.showAmbiances = false;
						this.ambianceTrigger = false;

						this.playSunDiv = false;
						this.aboutDiv = true;

						this.showPrompt = false;
					} else if (this.showHelpOverlay === false){
						// clearInterval(this.aboutID);
						// clearInterval(this.about2ID);
						
						this.voice1Div = true;
						this.voice2Div = true;
						this.voice3Div = true;
						this.voice4Div = true;

						this.playSunDiv = true;
						this.aboutDiv = false;
				}
					
			},
			promptFunc(){
				this.promptTrigger = !this.promptTrigger;
				
				if (this.promptTrigger === false){
					this.showPrompt = false;

				} else if (this.promptTrigger === true){
				}

			},
			bellTrue(){
					this.bellBoolean = true;
			},
	//SLIDER SETTING
		sliderRangeSet(){
			let slider1 = document.getElementById ("sliders1"),
			 	slider2 = document.getElementById ("sliders2"),
			 	slider3 = document.getElementById ("sliders3"),
			 	slider4 = document.getElementById ("sliders4");
			// var slider5 = document.getElementById ("sliders5");

			let w = window,
			    	d = document,
			    	e = d.documentElement,
			    	g = d.getElementsByTagName('body')[0],
				 	x = w.innerWidth || e.clientWidth || g.clientWidth,
    			 	y = w.innerHeight|| e.clientHeight|| g.clientHeight;

			if (window.innerWidth <= 349){
				slider1.max = 150;
				slider1.min = 100;

				slider2.max = 150;
				slider2.min = 100;

				slider3.max = 150;
				slider3.min = 100;

				slider4.max = 150;
				slider4.min = 100;

				// slider5.max = 150;
				// slider5.min = 100;

				this.sliderMin = 100;
				this.reverbColoringVar = 2.5;

				// this.reverbRadius = 150;

				// this.aboutRadius  = 100;
				// this.about2Radius = 150;

				this.voice1Radius = 100;
				this.voice2Radius = 100;
				this.voice3Radius = 100;
				this.voice4Radius = 100;

				this.playSunDraggie.setPosition( (x * 0.34), (y / 3.35) );

  				this.aboutDraggie.setPosition( (x * 0.2), (y * 0.88) );
				this.about2Draggie.setPosition( (x * 0.1), (y * 1.43) );
				this.about3Draggie.setPosition( (x * 0.0001), (y * 0.15) );
				this.about4Draggie.setPosition( (x * 0.15), (y * 1.9) );

			} else if (window.innerWidth <= 576){
				slider1.max = 150;
				slider1.min = 100;

				slider2.max = 150;
				slider2.min = 100;

				slider3.max = 150;
				slider3.min = 100;

				slider4.max = 150;
				slider4.min = 100;

				// slider5.max = 150;
				// slider5.min = 100;

				this.sliderMin = 100;
				this.reverbColoringVar = 2.5;

				// this.reverbRadius = 150;

				// this.aboutRadius  = 100;
				// this.about2Radius = 150;

				this.voice1Radius = 100;
				this.voice2Radius = 100;
				this.voice3Radius = 100;
				this.voice4Radius = 100;

				this.playSunDraggie.setPosition( (x * 0.36), (y / 3.5) );

  				this.aboutDraggie.setPosition( (x * 0.3), (y * 0.7) );
				this.about2Draggie.setPosition( (x * 0.1), (y * 1.125) );
				this.about3Draggie.setPosition( (x * 0.06), (y * 0.125) );
				this.about4Draggie.setPosition( (x * 0.15), (y * 1.55) );

			} else if (window.innerWidth <= 768){
				slider1.max = 250;
				slider1.min = 145;

				slider2.max = 250;
				slider2.min = 145;

				slider3.max = 250;
				slider3.min = 145;

				slider4.max = 250;
				slider4.min = 145;

				// slider5.max = 250;
				// slider5.min = 145;

				this.sliderMin = 145;
				this.reverbColoringVar = 4;

				// this.reverbRadius = 250;

				// this.aboutRadius  = 100;
				// this.about2Radius = 150;

				this.voice1Radius = 145;
				this.voice2Radius = 145;
				this.voice3Radius = 145;
				this.voice4Radius = 145;

				this.playSunDraggie.setPosition( (x / 2.55), (y / 4));

  				this.aboutDraggie.setPosition( (x * 0.55), (y / 7) );
				this.about2Draggie.setPosition( (x * 0.5), (y / 2.2) );
				this.about3Draggie.setPosition( (x * 0.01), (y / 10) );
				this.about4Draggie.setPosition( (x * 0.15), (y * 0.5) );

			} else if (window.innerWidth <= 1024){
				slider1.max = 300;
				slider1.min = 175;

				slider2.max = 300;
				slider2.min = 175;

				slider3.max = 300;
				slider3.min = 175;

				slider4.max = 300;
				slider4.min = 175;

				// slider5.max = 300;
				// slider5.min = 175;

				this.sliderMin = 175;
				this.reverbColoringVar = 5;

				// this.reverbRadius = 300;

				// this.aboutRadius  = 200;
				// this.about2Radius = 200;

				this.voice1Radius = 175;
				this.voice2Radius = 175;
				this.voice3Radius = 175;
				this.voice4Radius = 175;

				this.playSunDraggie.setPosition( (x / 2.35), (y / 3));

  				this.aboutDraggie.setPosition( (x * 0.55), (160) );
				this.about2Draggie.setPosition( (x * 0.5), (500) );
				this.about3Draggie.setPosition( (x * 0.02), (100) );
				this.about4Draggie.setPosition( (x * 0.15), (570) );

			} else if (window.innerWidth <= 1299){
				slider1.max = 310;
				slider1.min = 175;

				slider2.max = 310;
				slider2.min = 175;

				slider3.max = 310;
				slider3.min = 175;

				slider4.max = 310;
				slider4.min = 175;

				// slider5.max = 310;
				// slider5.min = 175;

				this.sliderMin = 175;
				this.reverbColoringVar = 6.75;

				// this.reverbRadius = 310;

				// this.aboutRadius  = 100;
				// this.about2Radius = 300;

				this.voice1Radius = 175;
				this.voice2Radius = 175;
				this.voice3Radius = 175;
				this.voice4Radius = 175;

				this.playSunDraggie.setPosition( (x / 2.35), (y / 3));

				this.aboutDraggie.setPosition( (x * 0.53), (160) );
				this.about2Draggie.setPosition( (x * 0.415), (500) );
				this.about3Draggie.setPosition( (x * 0.08), (100) );
				this.about4Draggie.setPosition( (x * 0.15), (600) );

			} else if (window.innerWidth >= 1300){
				slider1.max = 400;
				slider1.min = 200;

				slider2.max = 400;
				slider2.min = 200;

				slider3.max = 400;
				slider3.min = 200;

				slider4.max = 400;
				slider4.min = 200;

				// slider5.max = 400;
				// slider5.min = 200;

				this.sliderMin = 200;
				this.sliderMax = 400;
				this.reverbColoringVar = 10;

				// this.reverbRadius = 400;

				// this.aboutRadius  = 100;
				// this.about2Radius = 300;

				this.voice1Radius = 200;
				this.voice2Radius = 200;
				this.voice3Radius = 200;
				this.voice4Radius = 200;

    			this.playSunDraggie.setPosition( (x / 2.25), (y / 3));

				this.aboutDraggie.setPosition( (x * 0.64), (160) );
				this.about2Draggie.setPosition( (x * 0.48), (600) );
				this.about3Draggie.setPosition( (x * 0.28), (100) );
				this.about4Draggie.setPosition( (x * 0.23), (600) );

				// (y / 2)
				// (y * 0.55)
			} 
		},
	//MASTER DRAGGIE LOGGING & LOADING
		holidayLoading(){
			this.voice1DraggieInit();
			this.voice2DraggieInit();
			this.voice3DraggieInit();
			this.voice4DraggieInit();
			this.playSunDraggieInit();
			this.aboutDraggieInit();
			this.about2DraggieInit();
			this.about3DraggieInit();
			this.about4DraggieInit();
			this.zeroDraggies();
		},
		zeroDraggies(){
			Draggabilly.prototype.setPosition = function( x, y ) {
			  this.position.x = x;
			  this.position.y = y;
			  this.setLeftTop();
			};

			// this.dragElem.style.left = '200px';
			// this.dragElem.style.top = '100px';

			var vm = this;

			setTimeout(function(){ 
			vm.playSunDiv = true;
			}, 1000);
		},
		ogScreenSize(){
			this.ogWidth = window.innerWidth;
		},
		screenSizing(){
			this.screenHeight = window.innerHeight;
			this.screenWidth = window.innerWidth;

			var currentWidth = window.innerWidth;

			if (currentWidth === this.ogWidth){
				
			} else if (currentWidth != this.ogWidth) {
				this.sliderRangeSet();
				// this.mobileCheck();
				this.ogWidth = currentWidth;
				
			}
		},
		coordLog(){
			this.voice1DraggieWidth = this.voice1Draggie.position.x;
			this.voice1DraggieHeight = this.voice1Draggie.position.y;
			this.voice2DraggieWidth = this.voice2Draggie.position.x;
			this.voice2DraggieHeight = this.voice2Draggie.position.y;
			this.voice3DraggieWidth = this.voice3Draggie.position.x;
			this.voice3DraggieHeight = this.voice3Draggie.position.y;
			this.voice4DraggieWidth = this.voice4Draggie.position.x;
			this.voice4DraggieHeight = this.voice4Draggie.position.y;
			this.playSunDraggieWidth = this.playSunDraggie.position.x;
			this.playSunDraggieHeight = this.playSunDraggie.position.y;
			// this.aboutDraggieWidth = this.aboutDraggie.position.x;
			// this.aboutDraggieHeight = this.aboutDraggie.position.y;
			// this.about2DraggieWidth = this.about2Draggie.position.x;
			// this.about2DraggieHeight = this.about2Draggie.position.y;
			// this.about3DraggieWidth = this.about3Draggie.position.x;
			// this.about3DraggieHeight = this.about3Draggie.position.y;
			// console.log('logging coords');
			// console.log(this.playSunDraggieHeight);
		},
	//START MUSIC SUN
		startMusicSun(){
			this.musicStart();
			// this.sunText = "Harmony";
			// this.showHorn = false;
		},
	//VOICE 1 DRAGGIE
		voice1DraggieInit(){
			this.voice1Draggie = new Draggabilly( '.voice1Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  // handle: ".voice1Handle"
			});	
			
			if (this.voice1State == 5){
					this.celestavoice1();
					this.voice1CurrentInstrument = "CELESTA";
				} else if (this.voice1State == 4){
					this.stringsvoice1();
					this.voice1CurrentInstrument = "VIOLIN";
				} else if (this.voice1State == 3){
					this.pianovoice1();
					this.voice1CurrentInstrument = "PIANO";
				} else if (this.voice1State == 2){
					this.accordionvoice1();
					this.voice1CurrentInstrument = "ACCORDION";
				} else if (this.voice1State == 1){
					this.windsvoice1();
					this.voice1CurrentInstrument = "CLARINET";
				}
		this.voice1DraggieClick();
		this.voice1ID = setInterval(this.voice1Movement, 60);
		},
		voice1DraggieClick(){
			var vm = this;

			if (vm.userMobile === false){

				if (vm.voice1State < 5){
						vm.voice1State++;
					} else if (vm.voice1State == 5){
						vm.voice1State = 1;
					}

				if (vm.voice1State == 5){
					vm.celestavoice1();
					vm.voice1CurrentInstrument = "CELESTA";
				} else if (vm.voice1State == 4){
					vm.stringsvoice1();
					vm.voice1CurrentInstrument = "VIOLIN";
				} else if (vm.voice1State == 3){
					vm.pianovoice1();
					vm.voice1CurrentInstrument = "PIANO";
				} else if (vm.voice1State == 2){
					vm.accordionvoice1();
					vm.voice1CurrentInstrument = "ACCORDION";
				} else if (vm.voice1State == 1){
					vm.windsvoice1();
					vm.voice1CurrentInstrument = "CLARINET";
				}
			} else if (vm.userMobile === true){

			vm.voice1Draggie.on( 'pointerDown', function( event, pointer ) {	
				
				if (vm.voice1State < 5){
					vm.voice1State++;
				} else if (vm.voice1State == 5){
					vm.voice1State = 1;
				}

				if (vm.voice1State == 5){
					vm.celestavoice1();
					vm.voice1CurrentInstrument = "CELESTA";
				} else if (vm.voice1State == 4){
					vm.stringsvoice1();
					vm.voice1CurrentInstrument = "VIOLIN";
				} else if (vm.voice1State == 3){
					vm.pianovoice1();
					vm.voice1CurrentInstrument = "PIANO";
				} else if (vm.voice1State == 2){
					vm.accordionvoice1();
					vm.voice1CurrentInstrument = "ACCORDION";
				} else if (vm.voice1State == 1){
					vm.windsvoice1();
					vm.voice1CurrentInstrument = "CLARINET";
				}
			});
			}
		},
		voice1BadgeClick(){
			if (this.voice1State < 5){
						this.voice1State++;
					} else if (this.voice1State == 5){
						this.voice1State = 1;
					}

				if (this.voice1State == 5){
					this.celestavoice1();
					this.voice1CurrentInstrument = "CELESTA";
				} else if (this.voice1State == 4){
					this.stringsvoice1();
					this.voice1CurrentInstrument = "VIOLIN";
				} else if (this.voice1State == 3){
					this.pianovoice1();
					this.voice1CurrentInstrument = "PIANO";
				} else if (this.voice1State == 2){
					this.accordionvoice1();
					this.voice1CurrentInstrument = "ACCORDION";
				} else if (this.voice1State == 1){
					this.windsvoice1();
					this.voice1CurrentInstrument = "CLARINET";
				}
		},
		voice1Movement(){
				var sunX = this.playSunDraggieWidth;
				var sunY = this.playSunDraggieHeight;

				this.voice1cosVar += this.voice1Timing;
				this.voice1sinVar += this.voice1Timing;
				
				var newrotateX = sunX + this.voice1RadiusX * Math.cos(this.voice1cosVar);
				var newrotateY = sunY + this.voice1RadiusY * Math.sin(this.voice1sinVar);

				this.voice1Draggie.setPosition(newrotateX, newrotateY);
		},
	//VOICE 2 DRAGGIE
		voice2DraggieInit(){
			this.voice2Draggie = new Draggabilly( '.voice2Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  // handle: '.voice2Handle'
			});	
			if (this.voice2State == 5){
					this.celestavoice2();
					this.voice2CurrentInstrument = "CELESTA";
				} else if (this.voice2State == 4){
					this.stringsvoice2();
					this.voice2CurrentInstrument = "VIOLIN";
				} else if (this.voice2State == 3){
					this.pianovoice2();
					this.voice2CurrentInstrument = "PIANO";
				} else if (this.voice2State == 2){
					this.accordionvoice2();
					this.voice2CurrentInstrument = "ACCORDION";
				} else if (this.voice2State == 1){
					this.windsvoice2();
					this.voice2CurrentInstrument = "CLARINET";
				}
		this.voice2DraggieClick();
		this.voice2ID = setInterval(this.voice2Movement, 60);
		},
		voice2DraggieClick(){
			var vm = this;

			if (vm.userMobile === false){

				if (vm.voice2State < 5){
						vm.voice2State++;
					} else if (vm.voice2State == 5){
						vm.voice2State = 1;
					}

				if (vm.voice2State == 5){
					vm.celestavoice2();
					vm.voice2CurrentInstrument = "CELESTA";
				} else if (vm.voice2State == 4){
					vm.stringsvoice2();
					vm.voice2CurrentInstrument = "VIOLIN";
				} else if (vm.voice2State == 3){
					vm.pianovoice2();
					vm.voice2CurrentInstrument = "PIANO";
				} else if (vm.voice2State == 2){
					vm.accordionvoice2();
					vm.voice2CurrentInstrument = "ACCORDION";
				} else if (vm.voice2State == 1){
					vm.windsvoice2();
					vm.voice2CurrentInstrument = "CLARINET";
				}
			} else if (vm.userMobile === true){

			vm.voice2Draggie.on( 'pointerDown', function( event, pointer ) {	
				if (vm.voice2State < 5){
				vm.voice2State++;
				} else if (vm.voice2State == 5){
					vm.voice2State = 1;
				}

				if (vm.voice2State == 5){
					vm.celestavoice2();
					vm.voice2CurrentInstrument = "CELESTA";
				} else if (vm.voice2State == 4){
					vm.stringsvoice2();
					vm.voice2CurrentInstrument = "VIOLIN";
				} else if (vm.voice2State == 3){
					vm.pianovoice2();
					vm.voice2CurrentInstrument = "PIANO";
				} else if (vm.voice2State == 2){
					vm.accordionvoice2();
					vm.voice2CurrentInstrument = "ACCORDION";
				} else if (vm.voice2State == 1){
					vm.windsvoice2();
					vm.voice2CurrentInstrument = "CLARINET";
				}
			});
			}
		},
		voice2BadgeClick(){
			if (this.voice2State < 5){
						this.voice2State++;
					} else if (this.voice2State == 5){
						this.voice2State = 1;
					}

				if (this.voice2State == 5){
					this.celestavoice2();
					this.voice2CurrentInstrument = "CELESTA";
				} else if (this.voice2State == 4){
					this.stringsvoice2();
					this.voice2CurrentInstrument = "VIOLIN";
				} else if (this.voice2State == 3){
					this.pianovoice2();
					this.voice2CurrentInstrument = "PIANO";
				} else if (this.voice2State == 2){
					this.accordionvoice2();
					this.voice2CurrentInstrument = "ACCORDION";
				} else if (this.voice2State == 1){
					this.windsvoice2();
					this.voice2CurrentInstrument = "CLARINET";
				}
		},
		voice2Movement(){
				
				var sunX = this.playSunDraggieWidth;
				var sunY = this.playSunDraggieHeight;

				// var radiusX = this.voice2RadiusX;
				// var radiusY = this.voice2RadiusY;

				// var radiusX = 200;
				// var radiusY = 200;

				// if (this.voice2cosVar < 360){
					this.voice2cosVar += this.voice2Timing;
				// } else if (this.voice2cosVar === 360){
				// 	this.voice2cosVar = 0;
				// }

				// if (this.voice2sinVar < 360){
					this.voice2sinVar += this.voice2Timing;
				// } else if (this.voice2sinVar === 360){
				// 	this.voice2sinVar = 0;
				// }

				var newrotateX = sunX + this.voice2RadiusX * Math.cos(this.voice2cosVar);
				var newrotateY = sunY + this.voice2RadiusY * Math.sin(this.voice2sinVar);

				this.voice2Draggie.setPosition(newrotateX, newrotateY);
		},
	//VOICE 3 DRAGGIE
		voice3DraggieInit(){
			this.voice3Draggie = new Draggabilly( '.voice3Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  // handle: ".voice3Handle"
			});	
			if (this.voice3State == 5){
					this.celestavoice3();
					this.voice3CurrentInstrument = "CELESTA";
				} else if (this.voice3State == 4){
					this.stringsvoice3();
					this.voice3CurrentInstrument = "VIOLA";
				} else if (this.voice3State == 3){
					this.pianovoice3();
					this.voice3CurrentInstrument = "PIANO";
				} else if (this.voice3State == 2){
					this.accordionvoice3();
					this.voice3CurrentInstrument = "ACCORDION";
				} else if (this.voice3State == 1){
					this.windsvoice3();
					this.voice3CurrentInstrument = "CLARINET";
				}
		this.voice3DraggieClick();
		this.voice3ID = setInterval(this.voice3Movement, 60);
		},
		voice3DraggieClick(){
			var vm = this;

			if (vm.userMobile === false){

				if (vm.voice3State < 5){
						vm.voice3State++;
					} else if (vm.voice3State == 5){
						vm.voice3State = 1;
					}

				if (vm.voice3State == 5){
					vm.celestavoice3();
					vm.voice3CurrentInstrument = "CELESTA";
				} else if (vm.voice3State == 4){
					vm.stringsvoice3();
					vm.voice3CurrentInstrument = "VIOLA";
				} else if (vm.voice3State == 3){
					vm.pianovoice3();
					vm.voice3CurrentInstrument = "PIANO";
				} else if (vm.voice3State == 2){
					vm.accordionvoice3();
					vm.voice3CurrentInstrument = "ACCORDION";
				} else if (vm.voice3State == 1){
					vm.windsvoice3();
					vm.voice3CurrentInstrument = "CLARINET";
				}
			} else if (vm.userMobile === true){

			this.voice3Draggie.on( 'pointerDown', function( event, pointer ) {	
				
				if (vm.voice3State < 5){
				vm.voice3State++;
				} else if (vm.voice3State == 5){
					vm.voice3State = 1;
				}

				if (vm.voice3State == 5){
					vm.celestavoice3();
					vm.voice3CurrentInstrument = "CELESTA";
				} else if (vm.voice3State == 4){
					vm.stringsvoice3();
					vm.voice3CurrentInstrument = "VIOLA";
				} else if (vm.voice3State == 3){
					vm.pianovoice3();
					vm.voice3CurrentInstrument = "PIANO";
				} else if (vm.voice3State == 2){
					vm.accordionvoice3();
					vm.voice3CurrentInstrument = "ACCORDION";
				} else if (vm.voice3State == 1){
					vm.windsvoice3();
					vm.voice3CurrentInstrument = "CLARINET";
				}
			});
			}
		},
		voice3BadgeClick(){
			if (this.voice3State < 5){
						this.voice3State++;
					} else if (this.voice3State == 5){
						this.voice3State = 1;
					}

				if (this.voice3State == 5){
					this.celestavoice3();
					this.voice3CurrentInstrument = "CELESTA";
				} else if (this.voice3State == 4){
					this.stringsvoice3();
					this.voice3CurrentInstrument = "VIOLA";
				} else if (this.voice3State == 3){
					this.pianovoice3();
					this.voice3CurrentInstrument = "PIANO";
				} else if (this.voice3State == 2){
					this.accordionvoice3();
					this.voice3CurrentInstrument = "ACCORDION";
				} else if (this.voice3State == 1){
					this.windsvoice3();
					this.voice3CurrentInstrument = "CLARINET";
				}
		},
		voice3Movement(){
				
				var sunX = this.playSunDraggieWidth;
				var sunY = this.playSunDraggieHeight;

				// var radiusX = this.voice3RadiusX;
				// var radiusY = this.voice3RadiusY;

				// var radiusX = 300;
				// var radiusY = 300;

				// if (this.voice3cosVar < 360){
					 this.voice3cosVar += this.voice3Timing;
				// } else if (this.voice3cosVar === 360){
				// 	this.voice3cosVar = 0;
				// }

				// if (this.voice3sinVar < 360){
					this.voice3sinVar += this.voice3Timing;
				// } else if (this.voice3sinVar === 360){
				// 	this.voice3sinVar = 0;
				// }

				var newrotateX = sunX + this.voice3RadiusX * Math.cos(this.voice3cosVar);
				var newrotateY = sunY + this.voice3RadiusY * Math.sin(this.voice3sinVar);

				this.voice3Draggie.setPosition(newrotateX, newrotateY);
		},
	//VOICE 4 DRAGGIE
		voice4DraggieInit(){
			this.voice4Draggie = new Draggabilly( '.voice4Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  // handle: ".voice4Handle"
			});	
			if (this.voice4State == 5){
					this.celestavoice4();
					this.voice4CurrentInstrument = "CELESTA";
				} else if (this.voice4State == 4){
					this.stringsvoice4();
					this.voice4CurrentInstrument = "CELLO";
				} else if (this.voice4State == 3){
					this.pianovoice4();
					this.voice4CurrentInstrument = "PIANO";
				} else if (this.voice4State == 2){
					this.accordionvoice4();
					this.voice4CurrentInstrument = "ACCORDION";
				} else if (this.voice4State == 1){
					this.windsvoice4();
					this.voice4CurrentInstrument = "CLARINET";
				}
		this.voice4DraggieClick();
		this.voice4ID = setInterval(this.voice4Movement, 60);
		},
		voice4DraggieClick(){
			var vm = this;

			if (vm.userMobile === false){

				if (this.voice4State < 5){
						this.voice4State++;
					} else if (this.voice4State == 5){
						this.voice4State = 1;
					}

				if (this.voice4State == 5){
					this.celestavoice4();
					this.voice4CurrentInstrument = "CELESTA";
				} else if (this.voice4State == 4){
					this.stringsvoice4();
					this.voice4CurrentInstrument = "CELLO";
				} else if (this.voice4State == 3){
					this.pianovoice4();
					this.voice4CurrentInstrument = "PIANO";
				} else if (this.voice4State == 2){
					this.accordionvoice4();
					this.voice4CurrentInstrument = "ACCORDION";
				} else if (this.voice4State == 1){
					this.windsvoice4();
					this.voice4CurrentInstrument = "CLARINET";
				}
			} else if (vm.userMobile === true){

			this.voice4Draggie.on( 'pointerDown', function( event, pointer ) {	
				if (vm.voice4State < 5){
				vm.voice4State++;
				} else if (vm.voice4State == 5){
					vm.voice4State = 1;
				}

				if (vm.voice4State == 5){
					vm.celestavoice4();
					vm.voice4CurrentInstrument = "CELESTA";
				} else if (vm.voice4State == 4){
					vm.stringsvoice4();
					vm.voice4CurrentInstrument = "CELLO";
				} else if (vm.voice4State == 3){
					vm.pianovoice4();
					vm.voice4CurrentInstrument = "PIANO";
				} else if (vm.voice4State == 2){
					vm.accordionvoice4();
					vm.voice4CurrentInstrument = "ACCORDION";
				} else if (vm.voice4State == 1){
					vm.windsvoice4();
					vm.voice4CurrentInstrument = "CLARINET";
				}
			});
			}
		},
		voice4BadgeClick(){
			if (this.voice4State < 5){
						this.voice4State++;
					} else if (this.voice4State == 5){
						this.voice4State = 1;
					}

				if (this.voice4State == 5){
					this.celestavoice4();
					this.voice4CurrentInstrument = "CELESTA";
				} else if (this.voice4State == 4){
					this.stringsvoice4();
					this.voice4CurrentInstrument = "CELLO";
				} else if (this.voice4State == 3){
					this.pianovoice4();
					this.voice4CurrentInstrument = "PIANO";
				} else if (this.voice4State == 2){
					this.accordionvoice4();
					this.voice4CurrentInstrument = "ACCORDION";
				} else if (this.voice4State == 1){
					this.windsvoice4();
					this.voice4CurrentInstrument = "CLARINET";
				}
		},
		voice4Movement(){
				
				var sunX = this.playSunDraggieWidth;
				var sunY = this.playSunDraggieHeight;

				// var radiusX = this.voice4RadiusX;
				// var radiusY = this.voice4RadiusY;

				// var radiusX = 400;
				// var radiusY = 400;

				// if (this.voice4cosVar < 6){
					this.voice4cosVar += this.voice4Timing;
				// } else if (this.voice4cosVar === 6){
				// 	this.voice4cosVar = 0;
				// }

				// if (this.voice4sinVar < 6){
					this.voice4sinVar += this.voice4Timing;
				// } else if (this.voice4sinVar === 6){
				// 	this.voice4sinVar = 0;
				// }

				var newrotateX = sunX + this.voice4RadiusX * Math.cos(this.voice4cosVar);
				var newrotateY = sunY + this.voice4RadiusY * Math.sin(this.voice4sinVar);

				this.voice4Draggie.setPosition(newrotateX, newrotateY);
		},
	//PLAYSUN DRAGGIE
		playSunDraggieInit(){
			this.playSunDraggie = new Draggabilly( '.playSunDraggable', {
			  // options...
			  containment: '.draggieContainer'
			  // containment: true,
			  // handle: ".playSunHandle"
			});	
		this.playSunID = setInterval(this.playSunDraggieClick, 100);	
		},
		playSunDraggieClick(){
			if (this.startAudioBoolean){
							this.startAudio();
							this.startAudioBoolean = false;
						}  
			var vm = this; 
			//Triggered when dragging starts and the element starts moving. Dragging starts after the user's pointer has moved a couple pixels to allow for clicks.
			

			this.playSunDraggie.on( 'dragStart', function( event, pointer ) {

					// var lowFreq = Math.floor((Math.random() * 800) + 600);
					// var highFreq = Math.floor((Math.random() * 1200) + 750);
					// var gainBoost = Math.floor((Math.random() * 10) -1);

					// vm.fxEQ.lowFrequency.value = lowFreq;
					// vm.fxEQ.highFrequency.value = highFreq;
					// vm.fxEQ.mid.value = gainBoost;

					// console.log(lowFreq);
					// console.log(highFreq);
					// console.log(gainBoost);

			});
		//Triggered when dragging moves.
			this.playSunDraggie.on( 'dragMove', function( event, pointer, moveVector ) {

				});
		//Triggered when dragging ends.
			this.playSunDraggie.on( 'dragEnd', function( event, pointer ) {
			});
		//Triggered when the user's pointer (mouse, touch, pointer) presses down.
			this.playSunDraggie.on( 'pointerDown', function( event, pointer ) {

			if (vm.sunDisableBoolean === true){	

				if (vm.activeSun === false){
					
					vm.showMutePrompt = false;

					vm.showHorn = false;

					setTimeout(function(){ 
					vm.showNavBar = true;
					}, 1);

					setTimeout(function(){ 
					vm.voice1Div = true;
					}, 400);

					setTimeout(function(){ 
					vm.voice2Div = true;
					}, 600);

					setTimeout(function(){ 
					vm.voice3Div = true;
					}, 800);

					setTimeout(function(){ 
					vm.voice4Div = true;
					}, 1000);

					setTimeout(function(){ 
					vm.showPrompt = true;
					}, 1200);

					vm.startAudio();

					setTimeout(vm.startMusicSun, 50);

					vm.activeSun = true;

					vm.sunLoad1 = "",
					vm.sunLoad2 = "",
					vm.sunText = 'AULD LANG SYNE';
					vm.sunText2 = 'FOUR-PART HARMONY';

					clearInterval(vm.playSunID);

					setTimeout(vm.engageAllTogether, 2000);

				} else if (vm.activeSun === true){
					
				}

				if (vm.allowAllTogether === true){
					vm.allV1.mute = false;
					vm.allV2.mute = false;
					vm.allV3.mute = false;
					vm.allV4.mute = false;

					vm.voices1MasterVolume.mute = true;
					vm.voices2MasterVolume.mute = true;
					vm.voices3MasterVolume.mute = true;
					vm.voices4MasterVolume.mute = true;
					vm.sunText = "";
					vm.sunText2 = "";
					vm.sunLoad1 = "",
					vm.sunLoad2 = "",
					vm.allTogetherSunText = "ALL TOGETHER!";
					vm.voice1CurrentInstrument = "EVERYONE";
					vm.voice2CurrentInstrument = "EVERYONE";
					vm.voice3CurrentInstrument = "EVERYONE";
					vm.voice4CurrentInstrument = "EVERYONE";
				}
			}
			});
			//Triggered when the user's pointer moves.
			this.playSunDraggie.on( 'pointerMove', function( event, pointer, moveVector ) {
			});
			//Triggered when the user's pointer unpresses.
			this.playSunDraggie.on( 'pointerUp', function( event, pointer ) {
				if (vm.sunDisableBoolean === true){	
					vm.allV1.mute = true;
					vm.allV2.mute = true;
					vm.allV3.mute = true;
					vm.allV4.mute = true;
					vm.voices1MasterVolume.mute = false;
					vm.voices2MasterVolume.mute = false;
					vm.voices3MasterVolume.mute = false;
					vm.voices4MasterVolume.mute = false;
					vm.allTogetherSunText = "";
					vm.sunLoad1 = "",
					vm.sunLoad2 = "",
					vm.sunText = 'AULD LANG SYNE';
					vm.sunText2 = 'FOUR-PART HARMONY';

					if (vm.voice1State == 5){
						vm.voice1CurrentInstrument = "CELESTA";
					} else if (vm.voice1State == 4){
						vm.voice1CurrentInstrument = "VIOLIN";
					} else if (vm.voice1State == 3){
						vm.voice1CurrentInstrument = "PIANO";
					} else if (vm.voice1State == 2){
						vm.voice1CurrentInstrument = "ACCORDION";
					} else if (vm.voice1State == 1){
						vm.voice1CurrentInstrument = "CLARINET";
					}

					if (vm.voice2State == 5){
						vm.voice2CurrentInstrument = "CELESTA";
					} else if (vm.voice2State == 4){
						vm.voice2CurrentInstrument = "VIOLIN";
					} else if (vm.voice2State == 3){
						vm.voice2CurrentInstrument = "PIANO";
					} else if (vm.voice2State == 2){
						vm.voice2CurrentInstrument = "ACCORDION";
					} else if (vm.voice2State == 1){
						vm.voice2CurrentInstrument = "CLARINET";
					}

					if (vm.voice3State == 5){
						vm.voice3CurrentInstrument = "CELESTA";
					} else if (vm.voice3State == 4){
						vm.voice3CurrentInstrument = "VIOLA";
					} else if (vm.voice3State == 3){
						vm.voice3CurrentInstrument = "PIANO";
					} else if (vm.voice3State == 2){
						vm.voice3CurrentInstrument = "ACCORDION";
					} else if (vm.voice3State == 1){
						vm.voice3CurrentInstrument = "CLARINET";
					}

					if (vm.voice4State == 5){
						vm.voice4CurrentInstrument = "CELESTA";
					} else if (vm.voice4State == 4){
						vm.voice4CurrentInstrument = "CELLO";
					} else if (vm.voice4State == 3){
						vm.voice4CurrentInstrument = "PIANO";
					} else if (vm.voice4State == 2){
						vm.voice4CurrentInstrument = "ACCORDION";
					} else if (vm.voice4State == 1){
						vm.voice4CurrentInstrument = "CLARINET";
					}
				}
			});
			//Triggered when the user's pointer is pressed and unpressed and has not moved enough to start dragging.
			this.playSunDraggie.on( 'staticClick', function( event, pointer ) {
			});
		},
		engageAllTogether(){
		this.allowAllTogether = true;
		},
	//ABOUT DRAGGIE
		aboutDraggieInit(){
			this.aboutDraggie = new Draggabilly( '.aboutDraggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  handle: ".aboutHandle"
			});	
		// setInterval(this.aboutDraggieClick, 100);	
		},
		about2DraggieInit(){
			this.about2Draggie = new Draggabilly( '.about2Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  handle: ".aboutHandle"
			});	
		// setInterval(this.aboutDraggieClick, 100);	
		},
		about3DraggieInit(){
			this.about3Draggie = new Draggabilly( '.about3Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  handle: ".aboutHandle"
			});	
		// setInterval(this.aboutDraggieClick, 100);	
		},
		about4DraggieInit(){
			this.about4Draggie = new Draggabilly( '.about4Draggable', {
			  // options...
			  // containment: '.draggieContainer'
			  // containment: true,
			  handle: ".aboutHandle"
			});	
		// setInterval(this.aboutDraggieClick, 100);	
		},
	//INSTRUMENT ENGAGE
		stringsvoice1(){
			this.stringsVoice1Boolean = !this.stringsVoice1Boolean;
			
			if (this.stringsVoice1Boolean === true){
				this.pianoVoice1Boolean = false;
				this.accordionVoice1Boolean = false;
				this.windsVoice1Boolean = false;
				this.celestaVoice1Boolean = false;

				this.stringsVoice1Player.mute = false;
				this.pianoVoice1Player.mute = true;
				this.accordionVoice1Player.mute = true;
				this.windsVoice1Player.mute = true;
				this.celestaVoice1Player.mute = true;
			} 

		},
		stringsvoice2(){
			this.stringsVoice2Boolean = !this.stringsVoice2Boolean;

			if (this.stringsVoice2Boolean === true){
				this.pianoVoice2Boolean = false;
				this.accordionVoice2Boolean = false;
				this.windsVoice2Boolean = false;
				this.celestaVoice2Boolean = false;

				this.stringsVoice2Player.mute = false;
				this.pianoVoice2Player.mute = true;
				this.accordionVoice2Player.mute = true;
				this.windsVoice2Player.mute = true;
				this.celestaVoice2Player.mute = true;
			} 
		},
		stringsvoice3(){
			this.stringsVoice3Boolean = !this.stringsVoice3Boolean;

			if (this.stringsVoice3Boolean === true){
				this.pianoVoice3Boolean = false;
				this.accordionVoice3Boolean = false;
				this.windsVoice3Boolean = false;
				this.celestaVoice3Boolean = false;

				this.stringsVoice3Player.mute = false;
				this.pianoVoice3Player.mute = true;
				this.accordionVoice3Player.mute = true;
				this.windsVoice3Player.mute = true;
				this.celestaVoice3Player.mute = true;
			} 
		},
		stringsvoice4(){
			this.stringsVoice4Boolean = !this.stringsVoice4Boolean;

			if (this.stringsVoice4Boolean === true){
				this.pianoVoice4Boolean = false;
				this.accordionVoice4Boolean = false;
				this.windsVoice4Boolean = false;
				this.celestaVoice4Boolean = false;

				this.stringsVoice4Player.mute = false;
				this.pianoVoice4Player.mute = true;
				this.accordionVoice4Player.mute = true;
				this.windsVoice4Player.mute = true;
				this.celestaVoice4Player.mute = true;
			} 
		},
		pianovoice1(){
			this.pianoVoice1Boolean = !this.pianoVoice1Boolean;

			if (this.pianoVoice1Boolean === true){
				this.stringsVoice1Boolean = false;
				this.accordionVoice1Boolean = false;
				this.windsVoice1Boolean = false;
				this.celestaVoice1Boolean = false;

				this.stringsVoice1Player.mute = true;
				this.pianoVoice1Player.mute = false;
				this.accordionVoice1Player.mute = true;
				this.windsVoice1Player.mute = true;
				this.celestaVoice1Player.mute = true;
			} 
		},
		pianovoice2(){
			this.pianoVoice2Boolean = !this.pianoVoice2Boolean;

			if (this.pianoVoice2Boolean === true){
				this.stringsVoice2Boolean = false;
				this.accordionVoice2Boolean = false;
				this.windsVoice2Boolean = false;
				this.celestaVoice2Boolean = false;

				this.stringsVoice2Player.mute = true;
				this.pianoVoice2Player.mute = false;
				this.accordionVoice2Player.mute = true;
				this.windsVoice2Player.mute = true;
				this.celestaVoice2Player.mute = true;
			} 
		},
		pianovoice3(){
			this.pianoVoice3Boolean = !this.pianoVoice3Boolean;

			if (this.pianoVoice3Boolean === true){
				this.stringsVoice3Boolean = false;
				this.accordionVoice3Boolean = false;
				this.windsVoice3Boolean = false;
				this.celestaVoice3Boolean = false;

				this.stringsVoice3Player.mute = true;
				this.pianoVoice3Player.mute = false;
				this.accordionVoice3Player.mute = true;
				this.windsVoice3Player.mute = true;
				this.celestaVoice3Player.mute = true;
			} 
		},
		pianovoice4(){
			this.pianoVoice4Boolean = !this.pianoVoice4Boolean;

			if (this.pianoVoice4Boolean === true){
				this.stringsVoice4Boolean = false;
				this.accordionVoice4Boolean = false;
				this.windsVoice4Boolean = false;
				this.celestaVoice4Boolean = false;

				this.stringsVoice4Player.mute = true;
				this.pianoVoice4Player.mute = false;
				this.accordionVoice4Player.mute = true;
				this.windsVoice4Player.mute = true;
				this.celestaVoice4Player.mute = true;
			} 
		},
		accordionvoice1(){
			this.accordionVoice1Boolean = !this.accordionVoice1Boolean;

			if (this.accordionVoice1Boolean === true){
				this.stringsVoice1Boolean = false;
				this.pianoVoice1Boolean = false;
				this.windsVoice1Boolean = false;
				this.celestaVoice1Boolean = false;

				this.stringsVoice1Player.mute = true;
				this.pianoVoice1Player.mute = true;
				this.accordionVoice1Player.mute = false;
				this.windsVoice1Player.mute = true;
				this.celestaVoice1Player.mute = true;
			} 
		},
		accordionvoice2(){
			this.accordionVoice2Boolean = !this.accordionVoice2Boolean;

			if (this.accordionVoice2Boolean === true){
				this.stringsVoice2Boolean = false;
				this.pianoVoice2Boolean = false;
				this.windsVoice2Boolean = false;
				this.celestaVoice2Boolean = false;

				this.stringsVoice2Player.mute = true;
				this.pianoVoice2Player.mute = true;
				this.accordionVoice2Player.mute = false;
				this.windsVoice2Player.mute = true;
				this.celestaVoice2Player.mute = true;
			} 
		},
		accordionvoice3(){
			this.accordionVoice3Boolean = !this.accordionVoice3Boolean;

			if (this.accordionVoice3Boolean === true){
				this.stringsVoice3Boolean = false;
				this.pianoVoice3Boolean = false;
				this.windsVoice3Boolean = false;
				this.celestaVoice3Boolean = false;

				this.stringsVoice3Player.mute = true;
				this.pianoVoice3Player.mute = true;
				this.accordionVoice3Player.mute = false;
				this.windsVoice3Player.mute = true;
				this.celestaVoice3Player.mute = true;
			} 
		},
		accordionvoice4(){
			this.accordionVoice4Boolean = !this.accordionVoice4Boolean;

			if (this.accordionVoice4Boolean === true){
				this.stringsVoice4Boolean = false;
				this.pianoVoice4Boolean = false;
				this.windsVoice4Boolean = false;
				this.celestaVoice4Boolean = false;

				this.stringsVoice4Player.mute = true;
				this.pianoVoice4Player.mute = true;
				this.accordionVoice4Player.mute = false;
				this.windsVoice4Player.mute = true;
				this.celestaVoice4Player.mute = true;
			} 
		},
		windsvoice1(){
			this.windsVoice1Boolean = !this.windsVoice1Boolean;

			if (this.windsVoice1Boolean === true){
				this.stringsVoice1Boolean = false;
				this.pianoVoice1Boolean = false;
				this.accordionVoice1Boolean = false;
				this.celestaVoice1Boolean = false;

				this.stringsVoice1Player.mute = true;
				this.pianoVoice1Player.mute = true;
				this.accordionVoice1Player.mute = true;
				this.windsVoice1Player.mute = false;
				this.celestaVoice1Player.mute = true;
			} 
		},
		windsvoice2(){
			this.windsVoice2Boolean = !this.windsVoice2Boolean;

			if (this.windsVoice2Boolean === true){
				this.stringsVoice2Boolean = false;
				this.pianoVoice2Boolean = false;
				this.accordionVoice2Boolean = false;
				this.celestaVoice2Boolean = false;

				this.stringsVoice2Player.mute = true;
				this.pianoVoice2Player.mute = true;
				this.accordionVoice2Player.mute = true;
				this.windsVoice2Player.mute = false;
				this.celestaVoice2Player.mute = true;
			} 
		},
		windsvoice3(){
			this.windsVoice3Boolean = !this.windsVoice3Boolean;

			if (this.windsVoice3Boolean === true){
				this.stringsVoice3Boolean = false;
				this.pianoVoice3Boolean = false;
				this.accordionVoice3Boolean = false;
				this.celestaVoice3Boolean = false;

				this.stringsVoice3Player.mute = true;
				this.pianoVoice3Player.mute = true;
				this.accordionVoice3Player.mute = true;
				this.windsVoice3Player.mute = false;
				this.celestaVoice3Player.mute = true;
			} 
		},
		windsvoice4(){
			this.windsVoice4Boolean = !this.windsVoice4Boolean;

			if (this.windsVoice4Boolean === true){
				this.stringsVoice4Boolean = false;
				this.pianoVoice4Boolean = false;
				this.accordionVoice4Boolean = false;
				this.celestaVoice4Boolean = false;

				this.stringsVoice4Player.mute = true;
				this.pianoVoice4Player.mute = true;
				this.accordionVoice4Player.mute = true;
				this.windsVoice4Player.mute = false;
				this.celestaVoice4Player.mute = true;
			} 
		},
		celestavoice1(){
			this.celestaVoice1Boolean = !this.celestaVoice1Boolean;

			if (this.celestaVoice1Boolean === true){
				this.stringsVoice1Boolean = false;
				this.pianoVoice1Boolean = false;
				this.accordionVoice1Boolean = false;
				this.windsVoice1Boolean = false;

				this.stringsVoice1Player.mute = true;
				this.pianoVoice1Player.mute = true;
				this.accordionVoice1Player.mute = true;
				this.windsVoice1Player.mute = true;
				this.celestaVoice1Player.mute = false;
			} 
		},
		celestavoice2(){
			this.celestaVoice2Boolean = !this.celestaVoice2Boolean;

			if (this.celestaVoice2Boolean === true){
				this.stringsVoice2Boolean = false;
				this.pianoVoice2Boolean = false;
				this.accordionVoice2Boolean = false;
				this.windsVoice2Boolean = false;

				this.stringsVoice2Player.mute = true;
				this.pianoVoice2Player.mute = true;
				this.accordionVoice2Player.mute = true;
				this.windsVoice2Player.mute = true;
				this.celestaVoice2Player.mute = false;
			} 
		},
		celestavoice3(){
			this.celestaVoice3Boolean = !this.celestaVoice3Boolean;

			if (this.celestaVoice3Boolean === true){
				this.stringsVoice3Boolean = false;
				this.pianoVoice3Boolean = false;
				this.accordionVoice3Boolean = false;
				this.windsVoice3Boolean = false;

				this.stringsVoice3Player.mute = true;
				this.pianoVoice3Player.mute = true;
				this.accordionVoice3Player.mute = true;
				this.windsVoice3Player.mute = true;
				this.celestaVoice3Player.mute = false;
			} 
		},
		celestavoice4(){
			this.celestaVoice4Boolean = !this.celestaVoice4Boolean;

			if (this.celestaVoice4Boolean === true){
				this.stringsVoice4Boolean = false;
				this.pianoVoice4Boolean = false;
				this.accordionVoice4Boolean = false;
				this.windsVoice4Boolean = false;

				this.stringsVoice4Player.mute = true;
				this.pianoVoice4Player.mute = true;
				this.accordionVoice4Player.mute = true;
				this.windsVoice4Player.mute = true;
				this.celestaVoice4Player.mute = false;
			} 
		},
	//BUFFER LOADING
		bufferLoading(){
				var vm = this;

				Tone.Buffer.on('progress', function(){
				
				})
				Tone.Buffer.on('load', function(){
					vm.sunDisableBoolean = true;
					vm.zeroDraggies();
					vm.sunLoad1 = 'HARMONY';
					vm.sunLoad2 = 'CLICK TO EXPLORE';
					vm.bellTrue();
				})
		},
				FutureFitFunc(){
					this.FutureFit = 'Happy Holidays!';
				},
	//AUDIO ROUTING
		musicStart(){
			this.stringsVoice1Player.start();
			this.stringsVoice2Player.start();
			this.stringsVoice3Player.start();
			this.stringsVoice4Player.start();
			this.pianoVoice1Player.start();
			this.pianoVoice2Player.start();
			this.pianoVoice3Player.start();
			this.pianoVoice4Player.start();
			this.accordionVoice1Player.start();
			this.accordionVoice2Player.start();
			this.accordionVoice3Player.start();
			this.accordionVoice4Player.start();
			this.windsVoice1Player.start();
			this.windsVoice2Player.start();
			this.windsVoice3Player.start();
			this.windsVoice4Player.start();
			this.celestaVoice1Player.start();
			this.celestaVoice2Player.start();
			this.celestaVoice3Player.start();
			this.celestaVoice4Player.start();
			this.allV1.start();
			this.allV2.start();
			this.allV3.start();
			this.allV4.start();
			},
		musicStop(){
			this.stringsVoice1Player.stop();
			this.stringsVoice2Player.stop();
			this.stringsVoice3Player.stop();
			this.stringsVoice4Player.stop();
			this.pianoVoice1Player.stop();
			this.pianoVoice2Player.stop();
			this.pianoVoice3Player.stop();
			this.pianoVoice4Player.stop();
			this.accordionVoice1Player.stop();
			this.accordionVoice2Player.stop();
			this.accordionVoice3Player.stop();
			this.accordionVoice4Player.stop();
			this.windsVoice1Player.stop();
			this.windsVoice2Player.stop();
			this.windsVoice3Player.stop();
			this.windsVoice4Player.stop();
			this.celestaVoice1Player.stop();
			this.celestaVoice2Player.stop();
			this.celestaVoice3Player.stop();
			this.celestaVoice4Player.stop();
			this.allV1.stop();
			this.allV2.stop();
			this.allV3.stop();
			this.allV4.stop();
		},
		audioRouting(){
			this.stringsVoice1Player.connect(this.voices1MasterVolume);
			this.stringsVoice2Player.connect(this.voices2MasterVolume);
			this.stringsVoice3Player.connect(this.voices3MasterVolume);
			this.stringsVoice4Player.connect(this.voices4MasterVolume);
			this.pianoVoice1Player.connect(this.voices1MasterVolume);
			this.pianoVoice2Player.connect(this.voices2MasterVolume);
			this.pianoVoice3Player.connect(this.voices3MasterVolume);
			this.pianoVoice4Player.connect(this.voices4MasterVolume);
			this.accordionVoice1Player.connect(this.voices1MasterVolume);
			this.accordionVoice2Player.connect(this.voices2MasterVolume);
			this.accordionVoice3Player.connect(this.voices3MasterVolume);
			this.accordionVoice4Player.connect(this.voices4MasterVolume);
			this.windsVoice1Player.connect(this.voices1MasterVolume);
			this.windsVoice2Player.connect(this.voices2MasterVolume);
			this.windsVoice3Player.connect(this.voices3MasterVolume);
			this.windsVoice4Player.connect(this.voices4MasterVolume);
			this.celestaVoice1Player.connect(this.voices1MasterVolume);
			this.celestaVoice2Player.connect(this.voices2MasterVolume);
			this.celestaVoice3Player.connect(this.voices3MasterVolume);
			this.celestaVoice4Player.connect(this.voices4MasterVolume);		

			this.allV1.connect(this.allV1MasterVolume);
			this.allV2.connect(this.allV2MasterVolume);
			this.allV3.connect(this.allV3MasterVolume);
			this.allV4.connect(this.allV4MasterVolume);

			this.voices1MasterVolume.connect(this.masterVolumeSub);
			this.voices2MasterVolume.connect(this.masterVolumeSub);
			this.voices3MasterVolume.connect(this.masterVolumeSub);
			this.voices4MasterVolume.connect(this.masterVolumeSub);

			this.allV1MasterVolume.connect(this.masterVolumeSub);
			this.allV2MasterVolume.connect(this.masterVolumeSub);
			this.allV3MasterVolume.connect(this.masterVolumeSub);
			this.allV4MasterVolume.connect(this.masterVolumeSub);
		},
	//AUDIO LOADING
				hornLoadingFunc(){
					this.horn.load("../src/assets/horn.mp3", function(){
					});

					// this.horn2.load("../src/assets/horn2.wav", function(){
					// });

					this.hornLoading = setInterval(this.hornLoadStatus, 1);

					this.audioRouting();

				},
				hornLoadStatus(){
					if (this.horn.loaded === false){

					} else if (this.horn.loaded === true) {
						this.audioLoadingFunc();
						this.audioLoading = setInterval(this.audio1LoadStatus, 1);
						clearInterval(this.hornLoading);
					}

				},
				audioLoadingFunc(){


					this.windsVoice1Player.load("../src/assets/ClarinetV1.mp3", function(){
					});

					this.windsVoice2Player.load("../src/assets/ClarinetV2.mp3", function(){
					});

					this.windsVoice3Player.load("../src/assets/ClarinetV3.mp3", function(){
					});

					this.windsVoice4Player.load("../src/assets/ClarinetV4.mp3", function(){
					});

					this.celestaVoice1Player.load("../src/assets/CelestaV1.mp3", function(){
					});

					this.celestaVoice2Player.load("../src/assets/CelestaV2.mp3", function(){
					});

					this.celestaVoice3Player.load("../src/assets/CelestaV3.mp3", function(){
					});

					this.celestaVoice4Player.load("../src/assets/CelestaV4.mp3", function(){
					});

					
				},
				audio1LoadStatus(){
					
					if ((this.windsVoice1Player.loaded === true) &&
						(this.windsVoice2Player.loaded === true) && 
						(this.windsVoice3Player.loaded === true) &&
						(this.windsVoice4Player.loaded === true) &&
						(this.celestaVoice1Player.loaded === true) &&
						(this.celestaVoice2Player.loaded === true) &&
						(this.celestaVoice3Player.loaded === true) &&
						(this.celestaVoice4Player.loaded === true))
						
					{
						clearInterval(this.audioLoading);

						// this.sunDisableBoolean = true;
						this.bufferLoading();
						

						this.audioLoadingFunc2();
					}
				},
				audioLoadingFunc2(){		
					//SFX LOADING
					this.stringsVoice1Player.load("../src/assets/StringsV1.mp3", function(){
					});

					this.stringsVoice2Player.load("../src/assets/StringsV2.mp3", function(){
					});

					this.stringsVoice3Player.load("../src/assets/StringsV3.mp3", function(){
					});

					this.stringsVoice4Player.load("../src/assets/StringsV4.mp3", function(){
					});

					this.pianoVoice1Player.load("../src/assets/PianoV1.mp3", function(){
					});

					this.pianoVoice2Player.load("../src/assets/PianoV2.mp3", function(){
					});

					this.pianoVoice3Player.load("../src/assets/PianoV3.mp3", function(){
					});

					this.pianoVoice4Player.load("../src/assets/PianoV4.mp3", function(){
					});

					this.accordionVoice1Player.load("../src/assets/AccordionV1.mp3", function(){
					});

					this.accordionVoice2Player.load("../src/assets/AccordionV2.mp3", function(){
					});

					this.accordionVoice3Player.load("../src/assets/AccordionV3.mp3", function(){
					});

					this.accordionVoice4Player.load("../src/assets/AccordionV4.mp3", function(){
					});

					this.allV1.load("../src/assets/allV1.mp3", function(){
					});

					this.allV2.load("../src/assets/allV2.mp3", function(){
					});

					this.allV3.load("../src/assets/allV3.mp3", function(){
					});

					this.allV4.load("../src/assets/allV4.mp3", function(){
					});

					//AMBIENCE LOADING
					this.ambience1Player.load("../src/assets/ppl.mp3", function(){
					});

					this.ambience2Player.load("../src/assets/fire.mp3", function(){
					});

					this.ambience3Player.load("../src/assets/snow.mp3", function(){
					});

					this.ambience4Player.load("../src/assets/noisemaker.mp3", function(){
					});

					this.noisemaker.load("../src/assets/clanker.mp3", function(){
					});
				},							
	//AMBIENCE PLAY STOPS
					ambience1Func(){
						this.ambience1Boolean = !this.ambience1Boolean;
						if (this.ambience1Boolean === true){
							this.ambience1Player.start();
						} else if (this.ambience1Boolean === false){
							this.ambience1Player.stop();
						}	
					},
					ambience2Func(){
						this.ambience2Boolean = !this.ambience2Boolean;
						if (this.ambience2Boolean === true){
							this.ambience2Player.start();
						} else if (this.ambience2Boolean === false){
							this.ambience2Player.stop();
						}	
					},
					ambience3Func(){
						this.ambience3Boolean = !this.ambience3Boolean;
						if (this.ambience3Boolean === true){
							this.ambience3Player.start();
						} else if (this.ambience3Boolean === false){
							this.ambience3Player.stop();
						}	
					},
					ambience4Func(){
						this.ambience4Boolean = !this.ambience4Boolean;
						if (this.ambience4Boolean === true){
							this.ambience4Player.start();
						} else if (this.ambience4Boolean === false){
							this.ambience4Player.stop();
						}	
					},
	//TRANSPORT START N STOP
					// startStop(){
					// 		this.startStopTrigger = !this.startStopTrigger;
					// 	if (this.startStopTrigger === true){
					// 		this.musicStart();
					// 	} else if (this.startStopTrigger === false){
					// 		this.musicStop();
					// 	}	
					// },	
										
					startAudio(){
									// Tone.context = new AudioContext();
									StartAudioContext(Tone.context, "#playSunDivID");
					},
	//HORN BLOW
		hornBlow(){
			let vm = this;

			this.hornTrigger = !this.hornTrigger;

			this.horn.start();
				setTimeout(function(){
					vm.hornTrigger = false;
				}, 1400);
		},
		noiseMakerFunc(){
			let vm = this;

			this.noisemakerTrigger = !this.noisemakerTrigger;

			this.noisemaker.start();
				setTimeout(function(){
					vm.noisemakerTrigger = false;
				}, 1600);
		},
		inst1Engage(){
			this.whichHorn = true;

			this.horn1Playing = true;
			this.horn2Playing = false;
		},
		inst2Engage(){
			this.whichHorn = false;
			this.horn1Playing = false;
			this.horn2Playing = true;
		},

		}
	}
</script>
<style>

</style>





// WEBPACK FOOTER //
// harmony.vue?3db9f735